export const fr = {
  'authentification': {
    'bienvenu': 'Bienvenue',
    'commande_en_ligne': 'Commande en ligne',
    'compte_france_frais': 'Vous avez un compte ?',
    'connectez_vous': 'Connectez-vous',
    'premiere_connexion': 'Première connexion ?',
    'utiliser_email': 'Utilisez votre adresse email de contact pour vous enregistrer et accéder à votre compte.',
    'activer_compte': 'Connectez-vous',
    'devenir_client': 'Devenir client France Frais',
    'contactez_nous': 'Contactez-nous',
    'tout_proche': 'France Frais, tout proche',
    'de_vous': 'de vous !',
    'error': {
      'erreur_rencontree': 'Une erreur a été rencontrée',
      'valider_email': "Vous devez valider que vous êtes propriétaire de l'adresse email en cliquant sur l'email qui vous a été envoyé.",
      'email_envoye': 'Email envoyé, veuillez vérifier votre boîte email.',
      're_envoyer': 'Ré-envoyer',
      'erreur': 'Erreur',
      'champs_requis': 'Veuillez remplir tous les champs requis',
      'date_fin_validite_requise': 'La date de fin de validité est requise',
      'echec_demande_derogation': 'Échec de l\'envoi de la demande de dérogation',
      'erreur_inconnue': 'Une erreur inconnue est survenue',
      'contacter_commercial': 'veuillez contacter votre commercial.',
      'email_correspond_plus': 'Votre email ne correspond plus à un contact de notre base client. Veuillez contacter votre commercial.',
      'no_sandbox': 'Vous ne pouvez pas vous connecter à la sandbox.<br /><br />Pour accéder à France Frais Connect veuillez utiliser le lien suivant :<br /><br /><Link>https://ffconnect.france-frais.fr</Link>.',
      'switched': 'Vous avez changé de compte client dans un autre onglet. <br /><Link>Recharger</Link>',
      'not_representant': 'Accès refusé. Cette interface est réservée aux représentants commerciaux de France Frais.',
    }
  },
  'global': {
    'france_frais': 'France Frais',
    'erreur_chargement': 'Erreur lors du chargement',
    'selectionner': 'Sélectionner',
    'selectionne': 'Sélectionné',
    'produit': '{{count}} produit',
    'produit_one': '{{count}} produit',
    'produit_other': '{{count}} produits',
    'produit_many': '{{count}} produits',
    'produit_plural': '{{count}} produits',
    'panier': '{{count}} panier',
    'panier_one': '{{count}} panier',
    'panier_other': '{{count}} paniers',
    'panier_many': '{{count}} paniers',
    'panier_plural': '{{count}} paniers',
    'colis': '{{count}} colis',
    'colis_one': '{{count}} colis',
    'colis_other': '{{count}} colis',
    'colis_many': '{{count}} colis',
    'colis_plural': '{{count}} colis',
    'evenement': '{{count}} événement',
    'evenement_one': '{{count}} événement',
    'evenement_other': '{{count}} événements',
    'evenement_many': '{{count}} événements',
    'evenement_plural': '{{count}} événements',
    'annuler': 'Annuler',
    'valider': 'Valider',
    'retour': 'Retour',
    'fermer': 'Fermer',
    'voir': 'Voir',
    'remplacer': 'Remplacer',
    'consulter': 'Consulter',
    'choisir': 'Choisir',
    'creer': 'Créer la liste',
    'client_title': 'Client',
    'client': '{{count}} client',
    'client_one': '{{count}} client',
    'client_other': '{{count}} clients',
    'client_many': '{{count}} clients',
    'client_plural': '{{count}} clients',
    'a_valider': 'A valider',
    'promotion': 'Promotion',
    'produit_marche': 'Produit marché',
    'accueil': 'Accueil',
    'catalogue': 'Catalogue',
    'cadencier': 'Cadencier',
    'ub_essentielles': 'UB essentielles',
    'mon_cadencier': 'Mon cadencier',
    'listes': 'Listes',
    'mes_listes': 'Mes listes',
    'profil': 'Mon Espace',
    'recherche': 'Recherche',
    'chargement': 'Chargement',
    'revenir': 'Revenir',
    'connecter': 'Se connecter',
    'accepter': 'J’accepte',
    'refuser': 'Refuser',
    'voir_mon_panier': 'Voir mon panier',
    'choisir_livraison': 'Choisir une livraison',
    'logo': 'logo',
    'raison_sociale': 'raison sociale',
    'code': 'code',
    'attention': 'Attention',
    'modifier': 'Modifier',
    'compris': 'Compris',
    'jai_compris': 'J’ai compris',
    'alt_logo_france_frais': 'Logo France Frais',
    'jour': 'jour',
    'mois': 'mois',
    'mois_precedent': 'Mois précédent',
    'mois_suivant': 'Mois suivant',
    'date': 'date',
    'quantite': 'quantité',
    'fiche_produit': 'Fiche produit',
    'not_found': 'Non trouvé',
    'error': 'Erreur',
    'error_field_required': 'Ce champ est requis.',
    'loading': 'Chargement...',
    'clear_file': 'Effacer le fichier',
    'articles': 'Articles',
    'change_selection': 'Changer la sélection',
    'searching': 'Recherche...',
    'envoyer': 'Envoyer',
    'supprimer': 'Supprimer',
    'message': 'Message',
    'yes': 'Oui',
    'no': 'Non',
    'all': 'Tous',
    'reset_filters': 'Réinitialiser les filtres',
    'vous': 'Vous',
    'fichier_trop_volumineux': 'Le fichier "{{nom}}" dépasse la limite de 5 Mo',
    'reference': 'Référence',
    'telecharger': 'Télécharger',
  },
  'header_band': {
    'temps_restant': 'Pensez à commander au plus tôt pour votre prochaine livraison du <Text>{{date_de_livraison}}</Text> !',
    'contactez_nous': 'Contactez-nous'
  },
  'paiement_cb_notice': {
    'titre': 'Paiement par carte bancaire',
    'message': 'Seules les livraisons des {{jours}} prochains jours peuvent être commandées',
    'fermer': 'Fermer le bandeau'
  },
  'cadencier': {
    'retirer_des_produits': 'Retirer des produits',
    'cta_panier': 'Aller au panier',
    'mon_cadencier': 'Mon Cadencier',
    'quitter_edition': 'Quitter le mode édition',
    'chargement_cadencier': 'Chargement de votre cadencier',
    'effacer_recherche': 'Effacer la recherche',
    'aucun_article_filtre': 'Aucun article ne correspond aux filtres sélectionnés.',
    'aucune_ligne_tendance': 'Aucune ligne {{tendances}} dans ce cadencier',
    'filtres_tendance': {
      'tout': 'Tout',
      'en-hausse': 'En hausse',
      'gagne': 'Gagnées',
      'stable': 'Stables',
      'en-baisse': 'En baisse',
      'perdu': 'Perdues',
      'a-gagner': 'Non commandées',
    },
    'suggestion': {
      'texte': 'Suggestion : {{count}} {{unite}}.',
      'tooltip': 'Basé sur vos habitudes d\'achat',
      'remplir_avec_suggestions': 'Remplir mon panier automatiquement',
      'articles_ajoutes_au_panier': '{{count}} article ajouté au panier avec succès',
      'articles_ajoutes_au_panier_one': '{{count}} article ajouté au panier avec succès',
      'articles_ajoutes_au_panier_other': '{{count}} articles ajoutés au panier avec succès',
      'articles_ajoutes_au_panier_many': '{{count}} articles ajoutés au panier avec succès',
      'article_changement_quantite': 'La quantité de l’article a été modifiée avec succès',
      'remplissez_votre_panier': 'Votre panier en 1 clic !',
      'ajoutez_en_un_clic': 'Sur mesure : retrouvez en un clic vos produits et quantités habituels.',
      'quantite_suggeree_presente': 'Quantité ajoutée automatiquement selon vos habitudes - modifiez-la si besoin.',
      'savoir_plus': 'En savoir plus',
      'savoir_plus_tooltip': 'Les produits de votre Cadencier ayant une suggestion de quantité en fonction de vos habitudes seront ajoutés au panier.',
      'action_annulee': '{{count}} article annulé',
      'action_annulee_one': '{{count}} article annulé',
      'action_annulee_other': '{{count}} articles annulés',
      'action_annulee_many': '{{count}} articles annulés',
      'action_annulee_plural': '{{count}} articles annulés',
      'annulation_echouee': 'L’annulation a échoué',
      'ligne_introuvable': 'Ligne de panier non trouvée pour l\'article {{code_article}}',
      'pas_suggestions_disponibles': 'Pas de suggestions de quantité disponibles dans votre cadencier.',
    },
    tri: {
      'tri': 'Tri : ',
      'alphabetique': 'Alphabétique',
      'frequence': "Fréquence d'achat",
    },
    modale_retirer: {
      'titre': 'Retirer du cadencier',
      'selectionner_raison': 'Sélectionner la raison :',
      'raison_plus_de_commande': 'Je ne commande plus ce produit',
      'raison_pas_interesse': 'Je ne suis pas intéressé par ce produit',
      'raison_autre_similaire': 'J\'ai un autre produit similaire',
      'raison_deja_ailleurs': 'Je commande déjà ce produit ailleurs',
      'valider_et_retirer': 'Valider et Retirer du cadencier',
      'annuler': 'Annuler',
    },
  },
  'temperature_livraison': {
    'la_livraison_du': 'La livraison du',
    'surgeles_uniquement': 'Surgelés uniquement',
    'non_surgeles_uniquement': 'Non surgelés uniquement',
    'livraison_surgelee': 'Livraison surgelée',
    'pas_de_surgele': 'Pas de surgelé',
    'livraison_non_surgelee': 'Livraison non surgelée',
    'livraison_surgeles_uniquement': 'Livraison surgelées uniquement',
    'livraison_non_surgeles_uniquement': 'Livraison non surgelés uniquement',
    'est_livraison_surgeles_uniquement': 'est une livraison surgelés uniquement.',
    'est_livraison_non_surgeles_uniquement': 'est une livraison non surgelés uniquement.',
    'warning_temperature_ignoree': 'Attention : les produits affichés peuvent ne pas être disponibles pour cette température de livraison'
  },
  'toast': {
    'ajoute_panier_date': 'Produit <strong>ajouté au panier du {{date, datetime}}</strong>',
    'ajoute_panier_marketplace': 'Produit ajouté au panier {{marketplace}}',
    'modifie_panier_date': 'Quantité du produit modifiée <strong>dans votre panier du {{date, datetime}}</strong>',
    'supprime_panier': 'Produit supprimé du panier',
    'supprime_cadencier': 'Le produit n°{{code_article}} a été supprimé du cadencier',
    'supprime_cadencier_simulation': "Le produit n°{{code_article}} n'a pas réellement été supprimé du cadencier",
    'supprime_cadencier_safelive': "Le produit n°{{code_article}} a réellement été supprimé du cadencier.<br />Pour qu'il soit pris en compte, ajoutez-le du cadencier tout de suite",
    'supprime_liste': 'Le produit n°{{code_article}} a été supprimé de la liste',
    'warning_minimum': 'La quantité minimum est de {{minimum}}',
    'warning_arrondis': 'La quantité a été ajustée au multiple supérieur le plus proche (multiple:{{multiple}})',
    'ajout_preco': 'Le produit a été ajouté au panier du {{date, datetime}}',
    'unite_switchee': 'La quantité a changé pour faire <strong>{{quantite}} colis</strong>',
    'produit_introuvable_supprime': 'Le produit est introuvable et ne peut être supprimé.',
    'ajout_nouvelle_liste': 'La liste {{newListName}} a été créée',
    'ajout_liste': 'L’article a été ajouté à la liste',
    'article_deja_present': 'Cet article est déjà présent dans votre liste.',
    'ajout_cadencier': 'Le produit a été ajouté au cadencier',
    'ajout_cadencier_simulation': "Le produit n'a pas réellement été ajouté au cadencier",
    'ajout_cadencier_safelive': "Le produit a réellement été ajouté au cadencier.<br />Pour qu'il ne soit pas pris en compte, retirez-le du cadencier tout de suite",
    'panier_deplace': 'Panier déplacé au <strong>{{date, datetime}}</strong>',
    'panier_vidé': 'Le panier du {{date}} a été vidé',
    'produit_differe': 'Produit <strong>déplacé au panier du {{date}}.</strong>',
    'produit_differe_cta': 'N’oubliez pas de le valider au plus tôt.',
    'produit_remplace': 'Produit remplacé par {{libelle}}',
    'voir_panier': 'Voir le panier',
    'voir_liste': 'Voir la liste',
    'produit_precommande': 'Attention produit en précommande',
    'quantite_ajustee': 'La quantite a été ajustée à {{quantite}} {{unite}}',
    'donnees_rafraichies': 'Les données du client ont été mises à jour avec succès.',
    'panier_valide_simulation': "Votre panier a été controlé mais n'a pas réellement été transformé en commande dans Tolede.",
    'panier_valide_safelive': "Votre panier a réellement été transformé en commande dans Tolede.<br />Pour ne pas qu'elle soit préparée, il faut l'annuler tout de suite.",
    'prolonge_session': 'Votre session a été prolongée avec succès.',
    'prolongement_session_impossible': 'Impossible de prolonger votre session.',
    'clients_rafraichis': 'La liste des clients a été rafraîchie avec succès.',
    'cgv_reinitialisees': 'Les acceptations de CGV ont été réinitialisées pour tous les clients.',
    'invitation_envoyee': 'L’invitation a été envoyée avec succès à {{email}}.',
    'relance_envoyee': 'La relance a été envoyée avec succès à {{email}}.'
  },
  'panier': {
    'panier': 'Panier',
    'panier_pdf': 'Panier - Commande PDF',
    'pdf': 'PDF',
    'matching_filtre_tout': 'Tout',
    'matching_filtre_ok': 'Ok : {{nombre}}',
    'matching_filtre_alerte': 'À vérifier : {{nombre}}',
    'matching_filtre_bloquant': 'À vérifier en priorité : {{nombre}}',
    'matching_details': 'Détails',
    'matching_remplace': 'Remplacé',
    'matching_correspondance_initiale': 'Correspondance initiale',
    'matching_phrase': {
      'code_exact_libelle_exact': {
        'ok': 'Ligne OK car article reconnu (code et libellé exacts) et prix exact.',
        'alerte': 'Ligne à vérifier en raison d’un léger écart de prix ({{ecart}}). L’article a bien été reconnu (code et libellé exacts).',
        'ko': 'Ligne à vérifier en raison de l’écart de prix ({{ecart}}). L’article a bien été reconnu (code et libellé exacts).',
        'vide': 'Ligne à vérifier car le prix est absent et n’a pas pu être comparé. L’article a bien été reconnu (code et libellé exacts).'
      },
      'code_exact_libelle_proche': {
        'ok': 'Ligne OK car article reconnu (code exact mais libellé pas totalement exact) et prix exact.',
        'alerte': 'Ligne à vérifier en raison d’un léger écart de prix ({{ecart}}). L’article a bien été reconnu (code exact mais libellé pas totalement exact).',
        'ko': 'Ligne à vérifier en raison de l’écart de prix ({{ecart}}). L’article a bien été reconnu (code exact mais libellé pas totalement exact).',
        'vide': 'Ligne à vérifier car le prix est absent et n’a pas pu être comparé. L’article a bien été reconnu (code exact mais libellé pas totalement exact).'
      },
      'code_exact_libelle_non_reconnu': {
        'ok': 'Ligne à vérifier : le code est exact mais le libellé n’est pas reconnu, risque d’erreur sur l’article. Le prix est exact.',
        'alerte': 'Ligne à vérifier : le code est exact mais le libellé n’est pas reconnu, avec un léger écart de prix ({{ecart}}).',
        'ko': 'Ligne à vérifier : le code est exact mais le libellé n’est pas reconnu, et le prix s’écarte de {{ecart}}.',
        'vide': 'Ligne à vérifier : le code est exact mais le libellé n’est pas reconnu, et le prix est absent.'
      },
      'code_different_libelle_exact': {
        'ok': 'Ligne OK car article reconnu (libellé exact mais code différent) et prix exact.',
        'alerte': 'Ligne à vérifier en raison d’un léger écart de prix ({{ecart}}). L’article a bien été reconnu (libellé exact mais code différent).',
        'ko': 'Ligne à vérifier en raison de l’écart de prix ({{ecart}}). L’article a bien été reconnu (libellé exact mais code différent).',
        'vide': 'Ligne à vérifier car le prix est absent et n’a pas pu être comparé. L’article a bien été reconnu (libellé exact mais code différent).'
      },
      'code_different_libelle_proche': {
        'ok': 'Ligne à vérifier car l’identification est incertaine (code différent et libellé pas totalement exact). Le prix est exact.',
        'alerte': 'Ligne à vérifier car l’identification est incertaine (code différent et libellé pas totalement exact), avec un léger écart de prix ({{ecart}}).',
        'ko': 'Ligne à vérifier car l’identification est incertaine (code différent et libellé pas totalement exact), et le prix s’écarte de {{ecart}}.',
        'vide': 'Ligne à vérifier car l’identification est incertaine (code différent et libellé pas totalement exact), et le prix est absent.'
      },
      'code_different_libelle_non_reconnu': {
        'ok': 'Ligne à vérifier : article non reconnu (ni le code ni le libellé ne correspondent), même si le prix est exact.',
        'alerte': 'Ligne à vérifier : article non reconnu (ni le code ni le libellé ne correspondent), avec un léger écart de prix ({{ecart}}).',
        'ko': 'Ligne à vérifier : article non reconnu (ni le code ni le libellé ne correspondent) et écart de prix ({{ecart}}).',
        'vide': 'Ligne à vérifier : article non reconnu (ni le code ni le libellé ne correspondent) et prix absent.'
      },
      'code_absent_libelle_exact': {
        'ok': 'Ligne OK car article reconnu (libellé exact, aucun code sur le bon de commande) et prix exact.',
        'alerte': 'Ligne à vérifier en raison d’un léger écart de prix ({{ecart}}). L’article a bien été reconnu (libellé exact, aucun code sur le bon de commande).',
        'ko': 'Ligne à vérifier en raison de l’écart de prix ({{ecart}}). L’article a bien été reconnu (libellé exact, aucun code sur le bon de commande).',
        'vide': 'Ligne à vérifier car le prix est absent et n’a pas pu être comparé. L’article a bien été reconnu (libellé exact, aucun code sur le bon de commande).'
      },
      'code_absent_libelle_proche': {
        'ok': 'Ligne à vérifier car l’identification est incertaine (aucun code sur le bon de commande et libellé pas totalement exact). Le prix est exact.',
        'alerte': 'Ligne à vérifier car l’identification est incertaine (aucun code sur le bon de commande et libellé pas totalement exact), avec un léger écart de prix ({{ecart}}).',
        'ko': 'Ligne à vérifier car l’identification est incertaine (aucun code sur le bon de commande et libellé pas totalement exact), et le prix s’écarte de {{ecart}}.',
        'vide': 'Ligne à vérifier car l’identification est incertaine (aucun code sur le bon de commande et libellé pas totalement exact), et le prix est absent.'
      },
      'code_absent_libelle_non_reconnu': {
        'ok': 'Ligne à vérifier : article non reconnu (aucun code sur le bon de commande et libellé non reconnu), même si le prix est exact.',
        'alerte': 'Ligne à vérifier : article non reconnu (aucun code sur le bon de commande et libellé non reconnu), avec un léger écart de prix ({{ecart}}).',
        'ko': 'Ligne à vérifier : article non reconnu (aucun code sur le bon de commande et libellé non reconnu) et écart de prix ({{ecart}}).',
        'vide': 'Ligne à vérifier : article non reconnu (aucun code sur le bon de commande et libellé non reconnu) et prix absent.'
      }
    },
    'matching_aucune_correspondance': 'Aucune correspondance',
    'matching_article_indisponible':
      'Article identifié mais non ajouté au panier',
    'matching_ligne_supprimee': 'Ligne du PDF retirée du panier',
    'matching_aucune_ligne_filtre': 'Aucune ligne ne correspond à ce filtre',
    'matching_resultat_ok': 'OK',
    'matching_resultat_ko': 'KO',
    'finaliser_commande': 'Vérifier et finaliser',
    'panier_vide': 'Votre panier est vide',
    'ajouter_au_panier': 'Ajouter au panier',
    'deja_au_panier': 'Déjà au panier',
    'panier_vide_cta': 'Commandez maintenant !',
    'panier_vide_cta_mobile': 'Vous pouvez commander dès maintenant',
    'panier_vide_cta_top': 'N’oubliez pas de valider vos paniers ouverts au plus tôt !',
    'paniers_ouverts': 'paniers ouverts',
    'paniers_ouverts_one': 'Panier ouvert',
    'paniers_ouverts_other': 'Paniers ouverts',
    'livraison_48h_72h': 'Livraison sous 48 à 72h par MATFER',
    'livraison_48h_72h_court': 'Livraison sous 48h à 72h',
    'paniers': 'Panier',
    'paniers_one': 'Panier',
    'paniers_other': 'Paniers',
    'paniers_plural': 'Paniers',
    'paniers_many': 'Paniers',
    'paniers_actifs': 'Panier actif',
    'paniers_actifs_one': 'Panier actif',
    'paniers_actifs_other': 'Paniers actifs',
    'paniers_actifs_plural': 'Paniers actifs',
    'paniers_actifs_many': 'Paniers actifs',
    'paniers_label': 'panier',
    'paniers_label_one': 'panier',
    'paniers_label_other': 'paniers',
    'paniers_label_plural': 'paniers',
    'paniers_label_many': 'paniers',
    'livraison_selectionnee': 'Livraison sélectionnée',
    'depuis_cadencier': 'Mon cadencier',
    'depuis_catalogue': 'Depuis le catalogue',
    'depuis_listes': 'Depuis mes listes',
    'remplacement_de': 'Remplacement de {{produit}}',
    'pour_la_livraison_du': 'Pour la livraison du <strong>{{date, datetime}}</strong>',
    'pour_la_livraison_du_mobile': 'Livraison du <strong>{{date, datetime}}</strong>',
    'nous_validons': 'Nous validons votre panier',
    'menu_tooltip': 'Afficher le panier du {{date}}',
    'changer_date': 'Changer la date',
    'commander_pour_une_autre_date': 'Commander pour une autre date',
    'panier_a_valider': 'Mes paniers à valider',
    'x_panier_a_valider': '{{count}} panier à valider',
    'x_panier_a_valider_one': '{{count}} panier à valider',
    'x_panier_a_valider_other': '{{count}} paniers à valider',
    'x_panier_a_valider_plural': '{{count}} paniers à valider',
    'liste_livraisons_prompt_mobile': 'Commander pour une autre date',
    'supprimer_panier_confirm': 'Voulez-vous vraiment vider le panier ?',
    'supprimer_panier_action': 'Vider le panier',
    'supprimer_panier_action_mobile': 'Vider',
    'panier_en_cours': 'Panier en cours',
    'commande_existant': 'Commande existante pour ce jour de livraison',
    'listes': '{{count}} liste',
    'listes_one': '{{count}} liste',
    'listes_other': '{{count}} listes',
    'listes_plural': '{{count}} listes',
    'confirmer_adresse_livraison': {
      'titre': 'Confirmer votre adresse de livraison',
      'bouton_confirmer': 'Je confirme',
      'bouton_changer_adresse': 'Changer l\'adresse'
    },
    'error' : {
      'hors_delai': {
        'tolerance': 'Nous transmettons à nos services cette commande bien qu\'elle soit hors délai (heure limite de commande : {{heure_a_atteindre}}). Merci de votre vigilance pour vos futures commandes.',
        'surcout': 'Cette commande est hors délai (heure limite de commande : {{heure_a_atteindre}}). Un surcoût de {{surcout_a_valider}} euros est appliqué.',
        'bloquant': 'L\'heure de la commande est supérieure au délai maximum acceptable (heure limite de commande : {{heure_a_atteindre}}).',
      },
      'franco': {
        'tolerance': {
          'montant_a_atteindre': 'Nous transmettons à nos service cette commande bien qu\'elle n\'atteigne pas le montant minimum (minimum de commande : {{montant_a_atteindre}} euros). Merci de votre vigilance pour vos futures commandes.',
          'poids_a_atteindre': 'Nous transmettons à nos service cette commande bien qu\'elle n\'atteigne pas le poids minimum (minimum de commande : {{poids_a_atteindre}} kg). Merci de votre vigilance pour vos futures commandes.',
          'montant_a_atteindre_et_poids_a_atteindre': 'Nous transmettons à nos service cette commande bien qu\'elle n\'atteigne pas le montant et le poids minimums (minimum de commande : {{montant_a_atteindre}} euros, {{poids_a_atteindre}} kg). Merci de votre vigilance pour vos futures commandes.',
        },
        'surcout': {
          'montant_a_atteindre': 'Cette commande n\'atteint pas le montant minimum de commande (minimum de commande : {{montant_a_atteindre}} euros). Un surcoût de {{surcout_a_valider}} euros est appliqué.',
          'poids_a_atteindre': 'Cette commande n\'atteint pas le poids minimum de commande (minimum de commande : {{poids_a_atteindre}} kg). Un surcoût de {{surcout_a_valider}} euros est appliqué.',
          'montant_a_atteindre_et_poids_a_atteindre': 'Cette commande n\'atteint pas le montant et poids minimums de commande (minimum de commande : {{montant_a_atteindre}} euros, {{poids_a_atteindre}} kg). Un surcoût de {{surcout_a_valider}} euros est appliqué.',
        },
        'bloquant': {
          'montant_a_atteindre': 'Cette commande n\'atteint pas le montant minimum de commande (minimum de commande : {{montant_a_atteindre}} euros).',
          'poids_a_atteindre': 'Cette commande n\'atteint pas le poids minimum de commande (minimum de commande : {{poids_a_atteindre}} kg).',
          'montant_a_atteindre_et_poids_a_atteindre': 'Cette commande n\'atteint pas le montant et poids minimums de commande (minimum de commande : {{montant_a_atteindre}} euros, {{poids_a_atteindre}} kg).',
        },
      }
    },
    'vide': {
      'votre_panier_est_vide': 'Votre panier est vide.',
      'merci': 'Merci',
      'pour_votre_commande': 'pour votre commande !',
      'vous_allez_recevoir_email': 'Vous allez recevoir un email de confirmation dans quelques instants.',
      'consulter_detail_commande': 'Vous pouvez consulter le détail de votre commande à tout moment dans la section "Mes commandes".',
      'pour_toute_question': 'Pour toute question concernant votre commande, nous vous invitons à contacter votre conseiller.',
      'vous_avez_x_panier': 'Vous avez {{count}} panier à valider.',
      'vous_avez_x_panier_one': 'Vous avez {{count}} panier à valider.',
      'vous_avez_x_panier_other': 'Vous avez {{count}} paniers à valider.',
      'vous_avez_x_panier_plural': 'Vous avez {{count}} paniers à valider.',
      'validez_pour_reserver': 'Validez vos paniers en cours pour réserver vos stocks.',
      'n_oubliez_pas_de_valider_restant': 'N’oubliez pas de valider<br/>votre panier restant',
      'n_oubliez_pas_de_valider_restant_one': 'N’oubliez pas de valider<br/>votre panier restant',
      'n_oubliez_pas_de_valider_restant_other': 'N’oubliez pas de valider<br/>vos paniers restants',
      'n_oubliez_pas_de_valider_restant_many': 'N’oubliez pas de valider<br/>vos paniers restants',
      'n_oubliez_pas_de_valider_restant_plural': 'N’oubliez pas de valider<br/>vos paniers restants',
      'prenez_de_lavance': 'Prenez de l’avance !',
      'preparez_prochaine_livraison': 'Préparez dès maintenant votre prochaine livraison',
      'alt_carton_vide': 'Carton de commande vide'
    },
    'recap': {
      'recapitulatif': 'Récapitulatif',
      'valider_le_panier': 'Valider le panier',
      'valider_mon_panier': 'Valider mon panier',
      'valider_et_payer': 'Valider et payer',
      'total_ht': 'Total HT',
      'surcout_ht': 'Surcoût HT',
      'total_tva': 'Total TVA',
      'total_ttc': 'Total TTC',
      'tooltip_total_ht': 'Montant estimé sur la base des quantités commandés et sera ajusté lors de la livraison',
      'statut_tolede': 'Statut Tolede',
      'commande_impossible': 'La commande est impossible',
      'motif_blocage_non_precise': 'Motif non précisé',
      'accepter_conditions': "J'accepte <Link>les conditions générales de vente</Link>",
      'mode_de_rendu': {
        'enlevement': 'Retrait à l’entrepôt',
        'livraison': 'Livraison',
        'presta_direct': 'Livraison'
      },
      'modale_adresse': {
        'titre_enlevement': 'Récupérez votre commande à votre entrepôt',
        'titre_livraison': 'Livraison'
      },
      'reference_commande': 'Référence commande',
      'reference_commande_needed': 'Référence commande (obligatoire)*',
      'commentaire_commande': 'Commentaire',
      'commentaire_commande_placeholder': 'Ajouter un commentaire à votre commande...',
      'marketplace_livraison_titre': 'Livraison Service +',
      'marketplace_livraison_delai': 'Livré par MATFER sous 48h à 72h',
      'option_de_paiement': 'Option de paiement',
      'paiement_par_carte_bancaire': 'Paiement par carte bancaire',
      'tooltip_paiement': 'Si vous souhaitez utiliser d\'autres moyens de paiement, contactez votre commercial',
    },
    'validez': {
      'plus_de_2_jours': 'Validez votre panier pour bloquer les quantités.',
      'moins_de_2_jours': 'Plus que <strong>{{date}}</strong> pour être livré à la date choisie.'
    },
    'paiement': {
      'traitement_en_cours': 'Traitement du paiement en cours...',
      'ne_pas_fermer': 'Veuillez ne pas fermer cette page.',
      'erreur_initiation': 'Impossible d\'initier le paiement. Veuillez réessayer.',
      'retour_panier': 'Retour au panier',
      'transaction_echouee': 'La transaction n\'a pas pu aboutir',
      'redirection_panier': 'Vous allez être redirigé vers le panier',
    },
    'quantites_inhabituelles': {
      'titre': 'Quantités inhabituelles',
      'message': 'Les quantités de ces produits sont inhabituelles :',
      'message_one': 'Les quantités de ce produit sont inhabituelles :',
      'message_other': 'Les quantités de ces produits sont inhabituelles :',
      'message_plural': 'Les quantités de ces produits sont inhabituelles :',
      'message_suite': 'Voulez-vous valider votre commande ou modifier ces quantités ?',
      'modifier': 'Modifier',
      'valider': 'Valider',
    },
  },
  'bouton_achat': {
    'buy': 'Ajouter au panier',
    'buy_court': 'Ajouter',
    'ajouter_au_devis': 'Ajouter au devis',
    'produit_ajoute_au_devis': 'Produit ajouté',
    'preco': 'Précommander'
  },
  'ligne_produit': {
    'promotion_non_applicable':
      "La promotion ne s'applique pas à la date de livraison choisie",
    'soit_prix': 'soit {{prix}}€',
    'retirer_le_produit': 'Retirer',
    'poids_variable': 'Poids variable',
    'poids_variable_label': 'Le produit sera facturé au poids réel',
    'tva_percent': 'TVA {{tauxTVA}}%',
    'HT': 'HT',
    'TTC': 'TTC',
    'encart_dlc': 'DLC estimée : <strong>{{date}}</strong>',
    'encart_dlc_tooltip': 'DLC du jour pour une préparation du jour',
    'afficher_dlc_stock': 'Afficher DLC et stock',
    'indisponible': {
      'rupture_partielle': 'Seulement <strong>{{quantite_max}}</strong> est disponible <i>(quantité demandée: {{quantite_demande}})</i>',
      'rupture_partielle_one': 'Seulement <strong>{{quantite_max}}</strong> est disponible <i>(quantité demandée: {{quantite_demande}})</i>',
      'rupture_partielle_other': 'Seulement <strong>{{quantite_max}}</strong> sont disponibles <i>(quantité demandée: {{quantite_demande}})</i>',
      'rupture_partielle_plural': 'Seulement <strong>{{quantite_max}}</strong> sont disponibles <i>(quantité demandée: {{quantite_demande}})</i>',
      'rupture': 'Rupture ({{quantite}} {{unite}} au panier)',
      'delai_de_prepa_long': 'Cet article ne peut pas être préparé à temps pour cette livraison.',
      'delai_de_prepa_long_avec_date': 'Cet article ne peut pas être préparé à temps pour cette livraison. Prochaine date possible : <strong>{{date}}</strong>.',
      'generique': 'Un problème empêche la commande de cet article.',
      'date_dispo': 'Disponible à partir du <strong>{{date}}</strong>',
      'remplacer': 'Remplacer',
      'differer': 'Différer',
      'differer_livraison': 'Différer la livraison',
      'ajuster_quantite': 'Ajuster la quantité à {{quantite}} {{unite}}',
      'ajuster_quantite_court': 'Ajuster la quantité',
      'tooltip_ajuster_quantite': 'Ajuster à {{quantite}} {{unite}} au panier',
      'tooltip_rupture_totale': 'Retirer du panier',
      'entete': '<strong>{{count}} produit</strong> est indisponible pour le <strong>{{dateDeLivraison}}</strong>',
      'entete_one': '<strong>{{count}} produit</strong> est indisponible pour le <strong>{{dateDeLivraison}}</strong>',
      'entete_other': '<strong>{{count}} produits</strong> sont indisponibles pour le <strong>{{dateDeLivraison}}</strong>',
      'entete_plural': '<strong>{{count}} produits</strong> sont indisponibles pour le <strong>{{dateDeLivraison}}</strong>',
      'entete_no_date': '<strong>{{count}} produit</strong> est indisponible',
      'entete_no_date_one': '<strong>{{count}} produit</strong> est indisponible',
      'entete_no_date_other': '<strong>{{count}} produits</strong> sont indisponibles',
      'entete_no_date_plural': '<strong>{{count}} produits</strong> sont indisponibles',
      'produit_indisponible': 'Produit indisponible pour le {{dateDeLivraison}}',
      'produit_indisponible_short': 'Produit indisponible',
      'article_indisponible': 'Article indisponible',
    }
  },
  'disponibilite': {
    'precommande': 'Précommande',
    'a_partir': 'A partir du {{date}}'
  },
  'modale_livraison': {
    'header': {
      'selection_periode': 'Sélectionnez une période de livraison',
      'preco': 'Choisissez votre date de livraison',
      'changement_panier': 'Modifier la date de livraison',
      'default': 'Modifier la date de livraison',
      'ouvrir': 'Ouvrir un panier pour une autre date',
    },
    'preco': {
      'title': 'Produit en précommande',
      'info': 'Ce produit ne sera disponible qu’à partir des dates ci-dessous.',
      'date': 'Dates disponibles après le {{dateDebut, datetime}} :'
    },
    'legende': {
      'jour_selectionne': 'Jour de livraison sélectionné',
      'panier_en_cours': 'Panier en cours',
      'panier_valide': 'Panier validé'
    },
    'changer_date': 'Choisir cette date',
    'valider_date': 'Valider la date de livraison',
    'afficher_plus': 'Afficher plus de date',
    'nous-requetons-les-disponibilites-de-larticle': 'Nous requêtons les disponibilités de l’article'
  },
  'erreur404': {
    'alt_img_carton': 'carton vide au fond duquel est marqué "Oups!"',
    'c_est_bien_vide_ici': 'Humm... C’est bien vide ici',
    'pas_de_panique': 'Pas de panique, par ici pour le remplir :',
    'voir_cadencier': 'Voir mon cadencier',
    'voir_catalogue': 'Voir le catalogue',
    'retour_accueil': 'Retour à l’accueil'
  },
  'backoffice_erreur404': {
    'alt_img_carton': 'carton vide au fond duquel est marqué "Oups!"',
    'page_introuvable': 'Page introuvable',
    'verifier_url': 'Cette page n’existe pas ou n’existe plus. Vérifiez l’URL ou revenez à l’accueil de FFcommerce.',
    'retour_backoffice': 'Retour à l’accueil'
  },
  'error': {
    'tooltip_generique_details': '{{message}} ({{code}})',
    'introuvable_en_db': 'L’objet est introuvable en base de données.',
    'cgv_requise': 'L’acceptation des conditions générales de vente est requise.',
    'echec_call_api': 'Une erreur est survenue.',
    'item_catalogue_introuvable': 'Article non trouvé dans le catalogue.',
    'article_introuvable': 'Article non trouvé dans le base.',
    'quantite_invalide': 'La quantité n’est pas un multiple de commande client.',
    'code_adresse_de_livraison_inconnu': 'Cette adresse de livraison n’existe pas pour ce client.',
    'livraison_introuvable': 'Aucune livraison pour cette date et pour ce client.',
    'quantite_en_colis_indisponible': 'La quantité en colis n’est pas disponible pour cet article.',
    'unite_deja_selectionnee': 'L’unité demandée est déjà celle de la ligne.',
    'prix_a_zero': 'Le prix catalogue de cet article n’est pas renseigné.',
    'label_asset_introuvable': 'Le chargement d’une image a échoué.',
    'probleme_bloquant_sur_commande': 'L’enregistrement de la commande a échoué, vérifiez votre panier.',
    'article_deja_present_dans_le_devis': 'Article déjà présent dans le devis.',
    'article_deja_present_dans_le_panier': 'L’article est déjà présent dans le panier de la livraison cible.',
    'changement_mode_de_rendu_impossible': 'Impossible de changer le mode de rendu pour cette livraions.',
    'doublon_liste': 'Le produit est déjà présent dans cette liste.',
    'quantite_max_depassee': 'Quantité en stock insuffisante pour le produit <strong>{{libelle}}</strong><br />Maximum commandable: <strong>{{max}} {{unite}}</strong>.',
    'article_inconnu': "Informations de l'article introuvables.",
    'medias_non_touves': "Problème lors de la récupération des médias associés à l'article.",
    'panier_introuvable_en_db': 'Ce panier est introuvable,<br /><strong><Reload>veuillez rafraîchir votre page.</Reload></strong>.',
    'ligne_de_panier_introuvable_en_db': 'Cette ligne de panier est introuvable,<br /><strong><Reload>veuillez rafraîchir votre page.</Reload></strong>.',
    'panier_tolede_mode_desactive': "La transformation d'un panier en commande Tolede n'est pas autorisée.",
    'cadencier_tolede_mode_desactive': 'Les actions sur le cadencier ne sont pas autorisées.',
    'colis_ajuste': 'La quantité a été ajustée au colis le plus proche.',
    'controle_panier': "Une erreur s'est produite lors de la validation du panier.<br />Veuillez réessayer ultérieurement.",
    'commande_panier': "Le panier n'a pas pu être validé, veuillez réessayer ultérieurement.<br /><Contact>Si le problème persiste, merci de nous contacter</Contact>.",
    'controle_dispo': "Nous n'avons pas pu vérifier la disponibilité de l'article.<br />Veuillez réessayer ultérieurement.",
    'client_bloque': 'Vous ne pouvez pas effectuer de commande depuis ce compte, <Contact>veuillez nous contacter.</Contact>',
    'generique': 'Une erreur dans la commande empêche son traitement.',
    'quantite_trop_importante': 'Quantité trop importante pour un ou plusieurs produits.',
    'rupture': 'Le produit {{libelle}} est en rupture de stock.',
    'erreur_date_livraison': 'La date de livraison est antérieure à la date actuelle. Modifiez la date de votre commande.',
    'delai_livraison_trop_long_cb': 'Le paiement par carte bancaire n\'est possible que pour une livraison dans les 6 prochains jours.',
    'panier_sans_ligne': 'Le panier ne contient aucun produit.',
    'commande_deja_validee': 'Cette commande a déjà été validée.',
    'client_inconnu': 'Client inconnu.',
    'erreur_nb_lignes': 'Nombre de lignes incorrect.',
    'adresse_inconnue': 'Adresse de livraison inconnue.',
    'erreur_code_tournee': 'Code tournée incorrect.',
    'erreur_mode_de_rendu': 'Type de tournée incorrect.',
    'non_autorise': 'Article non présent dans le catalogue du client.',
    'article_obsolete': "L'article est obsolète.",
    'non_commercialise': "L'article n'est pas commercialisé.",
    'non_web': "L'article n'est pas disponible à la commande en ligne.",
    'erreur_temperature_tournee': "Impossible d'ajouter cet article pour cette tournée (température).",
    'erreur_multiple_de_commande': 'Multiple de commande incorrect.',
    'heure_depassee': 'Heure limite de commande dépassée.',
    'delai_de_prepa_long': 'Cet article ne peut pas être préparé à temps pour cette livraison.',
    'reference': 'Référence de commande incorrecte ou à saisir.',
    'prix_plancher': 'Prix saisi en dessous du prix plancher.',
    'deja_au_cadencier': "L'article est déjà présent dans le cadencier.",
    'erreur_cadencier': 'La modification du cadencier a été refusée.',
    'cadencier_desactive': "L'ajout au cadencier est temporairement désactivé.",
    "la valeur d'une clé dupliquée rompt la contrainte unique « liste_selection_pkey »": '$t(error.doublon_liste)',
    'duplicate key value violates unique constraint "liste_selection_pkey"': '$t(error.doublon_liste)',
    'dispo': {
      'erreur_generique': 'Une erreur liée à la disponibilité de l’article est survenue. Vérifiez votre panier.',
      'erreur_quantite_insuffisante': 'Stock insuffisant pour cet article. Vérifiez votre panier.'
    },
    'date_differer_manquante': 'Erreur: La date de la prochaine livraison de cet article n’a pas été communiquée',
    'rupture_article': 'La quantité souhaitée pour votre article est indisponible.',
    'no_client': 'Aucun client pour cette société commerciale.',
    'no_tournee': 'Aucune tournée de livraison programmée pour cette société commerciale.',
    'unknown': 'Une erreur est survenue lors de la recherche. Veuillez réessayer dans quelques instants.',
    'index.building': 'La préparation de l’index de recherche est en cours. Veuillez réessayer dans quelques instants.',
    'index.building_started': 'Nous sommes en train de préparer l’index de recherche. Veuillez réessayer dans quelques minutes.',
    'index.build_failed': 'Impossible de préparer l’index de recherche. Veuillez contacter le support.',
    'panier_pas_en_attente_paiement': 'Aucun paiement en attente pour ce panier.',
    'paiement_non_confirme': 'Le paiement a échoué. Veuillez réessayer.',
    'catalogue_grand_compte_unauthorized': 'Accès refusé. Vous n’avez pas accès au catalogue complet.',
  },
  'unite': {
    'B': 'bouteille',
    'B_one': 'bouteille',
    'B_other': 'bouteilles',
    'B_many': '$t(unite.B_other)',
    'B_plural': '$t(unite.B_other)',
    'BA': 'barquette',
    'BA_one': 'barquette',
    'BA_other': 'barquettes',
    'BA_many': '$t(unite.BA_other)',
    'BA_plural': '$t(unite.BA_other)',
    'BB': 'bocal',
    'BB_one': 'bocal',
    'BB_other': 'bocaux',
    'BB_many': '$t(unite.BB_other)',
    'BB_plural': '$t(unite.BB_other)',
    'BC': 'bac',
    'BC_one': 'bac',
    'BC_other': 'bacs',
    'BC_many': '$t(unite.BC_other)',
    'BC_plural': '$t(unite.BC_other)',
    'BI': 'bidon',
    'BI_one': 'bidon',
    'BI_other': 'bidons',
    'BI_many': '$t(unite.BI_other)',
    'BI_plural': '$t(unite.BI_other)',
    'BO': 'bourriche',
    'BO_one': 'bourriche',
    'BO_other': 'bourriches',
    'BO_many': '$t(unite.BO_other)',
    'BO_plural': '$t(unite.BO_other)',
    'BT': 'boite',
    'BT_one': 'boite',
    'BT_other': 'boites',
    'BT_many': '$t(unite.BT_other)',
    'BT_plural': '$t(unite.BT_other)',
    'BX': 'box',
    'BX_one': 'box',
    'BX_other': 'boxes',
    'BX_many': '$t(unite.BX_other)',
    'BX_plural': '$t(unite.BX_other)',
    'C1': 'C1',
    'C1_one': 'C1',
    'C1_other': 'C1',
    'C1_many': '$t(unite.C1_other)',
    'C1_plural': '$t(unite.C1_other)',
    'C2': 'C2',
    'C2_one': 'C2',
    'C2_other': 'C2',
    'C2_many': '$t(unite.C2_other)',
    'C2_plural': '$t(unite.C2_other)',
    'CA': 'carton',
    'CA_one': 'carton',
    'CA_other': 'cartons',
    'CA_many': '$t(unite.CA_other)',
    'CA_plural': '$t(unite.CA_other)',
    'CI': 'caissette',
    'CI_one': 'caissette',
    'CI_other': 'caissettes',
    'CI_many': '$t(unite.CI_other)',
    'CI_plural': '$t(unite.CI_other)',
    'CN': 'CN',
    'CN_one': 'CN',
    'CN_other': 'CN',
    'CN_many': '$t(unite.CN_other)',
    'CN_plural': '$t(unite.CN_other)',
    'CO': 'colis',
    'CO_one': 'colis',
    'CO_other': 'colis',
    'CO_many': '$t(unite.CO_other)',
    'CO_plural': '$t(unite.CO_other)',
    'CT': 'Cent',
    'CT_one': 'Cent',
    'CT_other': 'Cent',
    'CT_many': '$t(unite.CT_other)',
    'CT_plural': '$t(unite.CT_other)',
    'FU': 'fut',
    'FU_one': 'fut',
    'FU_other': 'futs',
    'FU_many': '$t(unite.FU_other)',
    'FU_plural': '$t(unite.FU_other)',
    'KG': 'kg',
    'KG_one': 'kg',
    'KG_other': 'kg',
    'KG_many': '$t(unite.KG_other)',
    'KG_plural': '$t(unite.KG_other)',
    'L': 'litre',
    'L_one': 'litre',
    'L_other': 'litres',
    'L_many': '$t(unite.L_other)',
    'L_plural': '$t(unite.L_other)',
    'LO': 'lot',
    'LO_one': 'lot',
    'LO_other': 'lots',
    'LO_many': '$t(unite.LO_other)',
    'LO_plural': '$t(unite.LO_other)',
    'MI': 'Mille',
    'MI_one': 'Mille',
    'MI_other': 'Milles',
    'MI_many': '$t(unite.MI_other)',
    'MI_plural': '$t(unite.MI_other)',
    'PI': 'pièce',
    'PI_one': 'pièce',
    'PI_other': 'pièces',
    'PI_many': '$t(unite.PI_other)',
    'PI_plural': '$t(unite.PI_other)',
    'PO': 'portion',
    'PO_one': 'portion',
    'PO_other': 'portions',
    'PO_many': '$t(unite.PO_other)',
    'PO_plural': '$t(unite.PO_other)',
    'PT': 'plateau',
    'PT_one': 'plateau',
    'PT_other': 'plateaux',
    'PT_many': '$t(unite.PT_other)',
    'PT_plural': '$t(unite.PT_other)',
    'SA': 'sac',
    'SA_one': 'sac',
    'SA_other': 'sacs',
    'SA_many': '$t(unite.SA_other)',
    'SA_plural': '$t(unite.SA_other)',
    'SO': 'seau',
    'SO_one': 'seau',
    'SO_other': 'seaux',
    'SO_many': '$t(unite.SO_other)',
    'SO_plural': '$t(unite.SO_other)',
    'SC': 'sac',
    'SC_one': 'sac',
    'SC_other': 'sacs',
    'SC_many': '$t(unite.SA_other)',
    'SC_plural': '$t(unite.SA_other)',
    'colis': 'colis',
    'colis_one': 'colis',
    'colis_other': 'colis',
    'colis_many': '$t(unite.colis_other)',
    'colis_plural': '$t(unite.colis_other)'
  },
  'month': {
    '1': 'janvier',
    '2': 'février',
    '3': 'mars',
    '4': 'avril',
    '5': 'mai',
    '6': 'juin',
    '7': 'juillet',
    '8': 'août',
    '9': 'septembre',
    '10': 'octobre',
    '11': 'novembre',
    '12': 'décembre'
  },
  'countries': {
    'FR': 'France',
    'ES': 'Espagne',
    'IT': 'Italie',
    'DE': 'Allemagne',
    'GB': 'Royaume-Uni',
    'US': 'États-Unis',
    'CN': 'Chine',
    'IN': 'Inde',
    'JP': 'Japon',
    'BR': 'Brésil',
    'RU': 'Russie',
    'CA': 'Canada',
    'AU': 'Australie',
    'KR': 'Corée du Sud',
    'MX': 'Mexique',
    'ID': 'Indonésie',
    'TR': 'Turquie',
    'NL': 'Pays-Bas',
    'SA': 'Arabie saoudite',
    'CH': 'Suisse',
    'PL': 'Pologne',
    'SE': 'Suède',
    'BE': 'Belgique',
    'AR': 'Argentine',
    'TH': 'Thaïlande',
    'AT': 'Autriche',
    'NO': 'Norvège',
    'IR': 'Iran',
    'ZA': 'Afrique du Sud',
    'DK': 'Danemark',
    'SG': 'Singapour',
    'MY': 'Malaisie',
    'CL': 'Chili',
    'UA': 'Ukraine',
    'SK': 'Slovaquie',
    'BG': 'Bulgarie',
    'EE': 'Estonie',
    'LT': 'Lituanie',
    'NZ': 'Nouvelle-Zélande',
    'LV': 'Lettonie',
    'CZ': 'République tchèque',
    'IS': 'Islande',
    'RO': 'Roumanie',
    'HR': 'Croatie',
    'MT': 'Malte',
    'HU': 'Hongrie',
    'CY': 'Chypre',
    'SI': 'Slovénie',
    'PT': 'Portugal',
    'IE': 'Irlande',
    'GR': 'Grèce',
    'FI': 'Finlande',
    'LU': 'Luxembourg',
    'MA': 'Maroc',
    'BQ': 'Pays-Bas caribéens',
    'IO': "Territoire britannique de l'océan Indien",
    'EG': 'Égypte',
    'BD': 'Bangladesh',
    'MG': 'Madagascar',
    'BA': 'Bosnie-Herzégovine',
    'VN': 'Vietnam',
    'PE': 'Pérou',
    'CI': "Côte d'Ivoire",
    'GL': 'Groenland',
    'LI': 'Liechtenstein',
    'AM': 'Arménie',
    'MN': 'Mongolie',
    'MD': 'Moldavie',
    'UY': 'Uruguay',
    'RS': 'Serbie',
    'GE': 'Géorgie',
    'FO': 'Îles Féroé',
    'GP': 'Guadeloupe',
    'PH': 'Philippines',
    'BO': 'Bolivie',
    'TN': 'Tunisie',
    'MU': 'Maurice'
  },
  'menu': {
    'compte': 'Mon compte',
    'informations': 'Mes informations',
    'commandes': 'Mes commandes',
    'commandes_passees': 'Mes commandes passées',
    'factures_et_avoirs': 'Mes factures',
    'bons_de_livraison': 'Mes bons de livraison',
    'preferences': 'Mes préférences',
    'changer_de_client': 'Changer de client',
    'deconnecter': 'Me déconnecter',
    'contacts': 'Mes contacts',
    'mes_droits': 'Mes droits',
    'mes_droits_synako': 'Sélection commercial',
    'passer_commande': 'Passer commande',
    'egalim': 'Mon ÉGalim',
  },
  'egalim': {
    'titre': 'Mon tableau de bord ÉGalim',
    'synthese_titre': 'Synthèse de mes achats ÉGalim',
    'montant_total': 'Total',
    'montant_euro': '{{montant}}€',
    'dont_bio': 'dont BIO',
    'dont_egalim': 'dont ÉGalim',
    'sur_montant_achat': 'sur {{montant}}€ d\'achat',
    'bio': 'Bio',
    'pourcentage_bio': '{{pourcentage}}% (Bio)',
    'pourcentage_egalim': '{{pourcentage}}% (ÉGalim)',
    'egalim': 'ÉGalim',
    'labels_officiels': 'Labels officiels ÉGalim',
    'labels_eligibles': 'Labels éligibles',
    'labels_eligibles_info':
      'Ces labels « éligibles » par certaines administrations sont à sélectionner par le client qui choisit ou non de les inclure à sa statistique',
    'labels_eligibles_selectionnes': 'Labels éligibles sélectionnés',
    'aucun': 'aucun',
    'poids_kg': '{{poids}} Kg',
    'details_par_label': 'Détails des achats par label',
    'exporter': 'Exporter ma synthèse ÉGalim (.xls)',
    'periode_debut': 'Début',
    'periode_fin': 'Fin',
    'selection_periode': 'Sélectionnez une période',
    'redirection_web': "Retrouvez l'ensemble de vos indicateurs ÉGalim directement sur la version web de France Frais Connect :\n\u2022 Visualisez votre taux BIO et ÉGalim en temps réel\n\u2022 Consultez le détail par label (Bio, Label Rouge, AOP…)\n\u2022  Exportez votre synthèse ÉGalim en .xls\n\u2022 Accédez à l'historique de vos achats et volumes par période\n\nPour profiter de toutes ces fonctionnalités, connectez-vous depuis un ordinateur à l'adresse habituelle de France Frais Connect, puis ouvrez la rubrique « Mon ÉGalim ».",
    'redirection_web_illustrations': 'Voici quelques illustrations de ce que vous pouvez retrouver sur le web dans votre rubrique « Mon ÉGalim » :',
    'montant_achat_total': 'Montant total',
  },
  'menu_livraison': {
    'tooltip': 'Cliquez pour commander pour une autre date.',
    'livraison': 'Livraison du <strong>{{date}}</strong>'
  },
  'bon_de_livraison': {
    'numero_de_commande': 'Numéro de commande',
    'date_de_commande': 'Date de commande',
    'total_de_commande': 'Total de commande',
    'bon_de_livraison_titre': 'Bon de livraison',
    'commande': 'Commande',
    'action': 'Action',
    'telecharger': 'Télécharger',
    'telecharger_tout': 'Télécharger tout',
    'bon_de_livraison': '{{count}} BON DE LIVRAISON',
    'bon_de_livraison_one': '{{count}} BON DE LIVRAISON',
    'bon_de_livraison_other': '{{count}} BONS DE LIVRAISON',
    'bon_de_livraison_many': '{{count}} BONS DE LIVRAISON',
    'bon_de_livraison_plural': '{{count}} BONS DE LIVRAISON',
    '2_derniers_mois': 'Les 2 derniers mois',
    '3_6_mois': 'De 3 à 6 mois',
    'N°': 'N°',
    'aucun_bon_de_livraison': 'Vous n’avez aucun bon de livraison sur cette période.'
  },
  'liste': {
    'mois': {
      'tout': 'Tout'
    },
    'date_range': {
      'select': 'Période',
      'selection': '',
      'debut': 'Date de début',
      'fin': 'Date de fin',
      'effacer': 'Effacer',
      'valider': 'Valider',
      'changer': 'Changer'
    },
    
    'par_periode': 'Par période',
    'categorie': 'Catégorie',
    'frequence_achat': 'Fréquence d\'achat',
    'filtre': {
      'selection_date': 'Sélectionner une période',
      'date_debut': 'Date de début',
      'date_fin': 'Date de fin',
      'appliquer': 'Appliquer',
      'reinitialiser': 'Réinitialiser'
    },
    'mes_listes': 'Mes listes',
    'mes_produits': 'Mes produits',
    'produits_par_saison': 'Mes produits par saison',
    'produits_par_saison_short': 'Par saison',
    'offre_commercial': "L'offre de mon commercial",
    'operation_commerciale': {
      'titre': 'En ce moment',
      'aucune' : 'Aucune opération commerciale en cours',
    },
    'devis_personnalise': {
      'titre': 'Proposition commerciale',
      'selection_commercial': 'Sélection préparée par votre commercial',
      'selection_commercial_avec_nom': 'Sélection préparée par {{prenom}} {{nom}}',
      'aucun_devis': 'Aucune proposition commerciale disponible',
      'note_commercial': 'La note de votre commercial',
      'mis_a_jour_le': 'Mis à jour le {{date}}',
      'voir_devis': 'Voir la proposition commerciale',
      'euro_ht': '€ HT/',
      'messages_commercial': 'Messages de votre commercial',
      'votre_commercial': 'Votre commercial',
      'vous': 'Vous',
      'commentaires': 'Commentaires',
      'ecrire_commentaire': 'Écrire votre commentaire',
      'commentaire_envoye_succes': 'Message envoyé avec succès',
      'commentaire_requis': 'Le message est requis',
      'nouveau_message': '{{count}} nouveau message',
      'nouveau_message_one': '{{count}} nouveau message',
      'nouveau_message_other': '{{count}} nouveaux messages',
      'non_lu': '{{count}} non lu',
      'non_lu_one': '{{count}} non lu',
      'non_lu_other': '{{count}} non lus',
      'non_lu_many': '{{count}} non lus',
      'non_lu_plural': '{{count}} non lus',
      'voir_plus': 'voir plus',
    },
    'creer_liste': 'Créer une nouvelle liste',
    'veuillez_entrer_nom_liste': 'Veuillez entrer le nom de la nouvelle liste',
    'veuillez_entrer_nouveau_nom_liste': 'Veuillez entrer le nouveau nom de la liste',
    'nom_liste_placeholder': 'Nom de la nouvelle liste',
    'liste_supprimee': 'La liste {{nom}} a été supprimée',
    'liste_renommee': 'La Liste a été renommée',
    'syntaxe_nom_liste': 'Seuls les lettres, les chiffres et les espaces sont autorisés',
    'ajouter_a_une_liste': 'Ajouter à une liste',
    'ajouter_a_la_liste': 'Ajouter à la liste',
    'dans_la_liste': 'Dans la liste',
    'ajouter_au_cadencier': 'Ajouter au Cadencier',
    'dans_le_cadencier': 'Dans le cadencier',
    'aria_label_modifier': 'Modifier le nom de la liste',
    'aria_label_enregistrer': 'Enregistrer le nouveau nom de la liste',
    'aria_label_renommer': 'Renommer la liste',
    'chargement_listes': 'Chargement de vos listes',
    'ajouter_article': 'Ajouter un article',
    'veuillez-selectionner-ou-ajouter-larticle': 'Veuillez sélectionner où ajouter l’article',
    'editer_nom_liste': 'Editer le nom de la liste',
    'supprimer_liste_confirm': 'Voulez-vous vraiment supprimer cette liste ?',
    'supprimer_liste_action': 'Supprimer la liste',
    'aucun_produit': 'Aucun produit dans cette liste',
    'selection_liste': 'Sélectionner une liste',
    'selectionner_liste_pour_ajout': 'Sélectionnez une liste pour ajouter des produits',
    'ajouter_produits': 'Ajouter les produits à',
    'choisir_une_liste': 'Choisir une liste',
    'tooltip_ajouter_cadencier': 'Ajouter les produits au cadencier',
    'liste': 'Liste :',
    'produit_ajoute': 'Produit ajouté à la liste',
    'aucune_liste': 'Aucune liste selectionnée',

    'historique_achat': 'Historique d’achat',
    'commande_x_fois': 'Commandé {{count}} fois',
    'produit_deja_dans_liste': 'Ce produit est déjà dans votre liste',
    'selectionner_liste_tooltip': 'Sélectionnez une liste',
    'quantite_saisonniere_tooltip': 'Quantité livrée sur la période sélectionnée',
    'trouver_alternative': 'Remplacer',
  },
  'operation_commerciale': {
    'voir_details': 'Découvrir',
    'retour': 'Retour',
    'jusqu_au': 'Jusqu\'au {{date}}',
    'article_hors_base': 'Article dans l\'opération commerciale mais pas dans la base FF ({{code_article}})'
  },
  'back_office': {
    'comment_ca_marche': 'Comment ça marche ?',
    'aucune_societe_commerciale': 'Aucune société commerciale disponible',
    'vide': 'Aucun élément', //
    maintenance: {
      'titleForm': 'Annonce de maintenance',
      form: {
        'date': 'Date',
        'heure_debut': 'Heure de début',
        'heure_fin': 'Heure de fin',
        'commence_le': 'Date et heure de début',
        'termine_le': 'Date et heure de fin',
        'commence_le_short': 'Commence le',
        'termine_le_short': 'Termine le',
        'message_fr': 'Message (FR)',
        'message_en': 'Message (EN)',
        'message_de': 'Message (DE)',
        'placeholder_message': 'Votre message…',
        'jours_avant': 'Afficher combien de jours avant (par défaut 1)',
        'enregistrer': 'Enregistrer',
        'creer': 'Créer une maintenance',
        'traduire': 'Traduire en anglais et en allemand',
      },
      toast: {
        'success': 'Annonce de maintenance enregistrée',
        'traduction_echouee': 'La traduction a échoué. Réessayez.',
      },
      preview: {
        'titre': 'Prévisualisation du bandeau',
      }
    },
    'unauthorized': 'Vous devez être connecté avec votre email France Frais.',
    'clients_ouverts': 'Statut Ouvert',
    'chercher_client': 'Chercher un client',
    'societes': 'Sociétés',
    'metier': 'Métier',
    'representant': 'Commercial',
    'liste_operations_commerciales' : 'Opérations commerciales',
    'liste_clients': 'Clients',
    'nouvelle_operation_commerciale': 'Nouvelle opération',
    'clients_avec_panier': 'Avec panier ouvert',
    'adresse_depot': "Adresse du dépôt d'enlèvement",
    'adresse_magasin': 'Adresse du magasin',
    'liste_societes_commerciales': 'Liste des sociétés commerciales',
    'nom_etablissement': "Nom de l'établissement",
    'etablissement': 'Établissement',
    'statut_tolede': 'Statut Tolede',
    'statut_tolede_ok': 'OK',
    'kpis': {
      'total_client': 'Total client',
      'connexion': 'Connexion',
      'connectes': 'Connectés',
      'non_connectes': 'Non connectés',
      'commandes': 'Commandes',
      'ayant_commande': 'Ayant commandé',
      'nayant_pas_commande': "N'ayant pas commandé",
      'toggle': {
        'trente_jours': '30 derniers jours',
        'depuis_debut': 'Depuis le début',
      },
    },
    'livraisons': 'Livraisons',
    'livraisons_sans_tournee': {
      'label': 'Pas de tournées',
      'description': "Lorsqu'aucune tournée n'est configurée dans Tolede, les clients n'ont pas accès à France Frais Connect.",
    },
    'filiale': 'filiale',
    'paniers': 'Paniers',
    'paniers_origine': {
      'client': 'Client',
      'representant': 'Commercial',
      'processus_pdf': 'Import PDF',
    },
    'paniers_origine_description': {
      'client': 'Paniers ouverts par le client',
      'representant': 'Paniers ouverts par le commercial',
      'processus_pdf': "Paniers issus d'un import PDF de commande",
    },
    'panier_en_cours': 'Panier en cours',
    'statut': 'Statut',
    'nombre_commandes': 'Nombre de commandes',
    'statut_tooltip': "Règle métier Tolede pour savoir si le client peut commander dans Tolede ou non (indépendamment d'un aspect digital)",
    'paniers_tooltip': 'Nombre de paniers du client ouverts',
    'cgv': 'CGV',
    'pas_de_client': 'Pas de client',
    'prochaine_date_livraison': 'Prochaine livraison le {{date_de_livraison}}',
    'cutoff_non_disponible': 'Cutt off non disponible',
    'rafraichir_clients': 'Rafraîchir la liste des clients',
    'rafraichir_clients_tooltip': 'Rafraîchit la liste des clients de la société.',
    'invitation_envoyee_le': 'Invitation envoyée le {{date}}',
    'relance_envoyee_le': 'Relance envoyée le {{date}}',
    'email_ouvert_le_tooltip': 'Vu le {{date}}',
    'envoyer_relance_tooltip': 'Envoyer une relance à {{email}}',
    'envoyer_invitation_tooltip': 'Envoyer une invitation à {{email}}',
    'relance_message_placeholder': 'Votre message personnalisé ... (optionnel)',
    'envoyer_email_relance': "Envoyer l'email",
    'relance_titre': 'Relance pour commander sur France Frais connect',
    'liste_emails_relance': 'À : ',
    'historique_invitation': "Historique de l'invitation",
    'historique_relance': 'Historique de la relance',
    'historique_emails_titre': 'Historique des emails',
    'email_ouvert_le': 'email ouvert le {{date}}',
    'pas_historique_email': 'Les détails de suivi ne sont plus disponibles (expirés après 45 jours)',
    'actions_client': {
      'conversations': 'Conversations',
      'etat_activation': "État de l'activation",
    },
    'etat_activation': {
      'contacts': 'Contacts',
      'connecte_le': 'Connecté - {{date}}',
      'invitation_envoyee_le': 'Invitation envoyée - {{date}}',
    },
    'activation_statut': {
      'connecte': 'Connecté',
      'non_connecte': 'Non connecté',
      'sans_email': 'Sans email',
      'a_commande': 'A commandé',
      'na_pas_commande': "N'a pas commandé",
    },
    'multicanal': 'Actif multi-canal',
    'activation': 'Statut FFConnect',
    'activation_tooltip': {
      'titre':
        "Statut d'activité FFConnect au cours des 30 derniers jours ({{periode}})",
      'connecte': 'Connecté : connexion sur FFConnect.',
      'a_commande': 'A commandé : commande validée via FFConnect.',
      'na_pas_commande':
        "N'a pas commandé : connecté mais aucune commande FFConnect.",
      'non_connecte': 'Non connecté : aucune connexion sur la période.',
      'sans_email':
        "Sans email : aucun email connu (impossible d'envoyer une invitation).",
      'note':
        'Les commandes saisies directement dans Tolede ne sont pas comptées.',
    },
    'jamais_validé': 'Jamais validé',
    'details_client': {
      'retour_clients': 'Retour à la liste des clients',
      'assistance_client': 'Vue Client',
      'prendre_une_commande': 'Prendre une commande',
      'voir_les_statistiques': 'Voir les statistiques',
      'informations_livraison': 'Informations de livraison',
      'informations_client': 'Informations client',
      'informations_societe': 'Informations société',
      'jours_de_livraison': 'Jours de livraison',
      'semaine_paire': 'Semaine paire',
      'semaine_impaire': 'Semaine impaire',
      'client_actionnaire': 'Client actionnaire',
      'tournees': 'Tournées',
      'parametrages': 'Paramétrages',
      'catalogue_client': 'Catalogue client',
      'rafraichir_catalogue': 'Rafraichir le catalogue',
      'cadencier_tendances': 'Cadencier',
      'tendance': {
        'en_hausse_one': 'En hausse',
        'en_hausse_other': 'En hausse',
        'gagne_one': 'Gagnée',
        'gagne_other': 'Gagnées',
        'stable_one': 'Stable',
        'stable_other': 'Stables',
        'en_baisse_one': 'En baisse',
        'en_baisse_other': 'En baisse',
        'perdu_one': 'Perdue',
        'perdu_other': 'Perdues',
        'a_gagner_one': 'Pas commandée',
        'a_gagner_other': 'Pas commandées',
      },
      'paniers_ouverts': 'Paniers ouverts',
      'rempli_par': {
        'client': 'Client',
        'representant': 'Commercial',
        'processus_pdf': 'PDF',
      },
      'mis_a_jour_le': 'Mis à jour le {{date}}',
      'reprendre_le_panier': 'Reprendre le panier',
      'consulter_le_panier': 'Consulter le panier',
      'dernieres_commandes': '{{count}} dernières commandes',
      'dernieres_commandes_one': '{{count}} dernière commande',
      'dernieres_commandes_other': '{{count}} dernières commandes',
      'dernieres_commandes_titre': 'Dernières commandes',
      'client_aucune_commande': "Le client n'a aucune commande",
      'toutes_les_commandes': 'Toutes les commandes',
      'ub_essentielles': 'UB essentielles',
      'ub_statut': {
        'gagne_one': 'Active',
        'gagne_other': 'Actives',
        'en_baisse_one': 'En baisse',
        'en_baisse_other': 'En baisse',
        'perdu_one': 'Perdue',
        'perdu_other': 'Perdues',
        'a_gagner_one': 'À gagner',
        'a_gagner_other': 'À gagner',
      },
      'contacts': 'Contacts',
      'contacts_tooltip': 'Liste des contacts cochés web dans Tolede et pouvant accéder à FFConnect',
      'code_client': 'Compte client',
      'paniers': 'Paniers',
      'panier_en_cours': 'Panier en cours',
      'panier_commercial': 'Panier commercial',
      'pas_de_panier_en_cours': 'Pas de panier en cours',
      'paniers_historique': 'Paniers',
      'paniers_historique_aria': "Voir l'historique des paniers",
      'paniers_historique_vide': 'Aucun événement de panier',
      'panier_event_id': 'Identifiant panier',
      'panier_event_statut': 'Statut du panier',
      'panier_event_date': "Date de l'event",
      'panier_event_message': 'Message',
      'panier_event_payload': 'Payload',
      'panier_event_valide': 'Validé',
      'panier_event_echec': 'Échec',
      'information_a_renseigner': 'Les informations sont à renseigner dans Tolede.',
      'rafraichissement': 'Rafraîchissement ...',
      'rafraichir_contacts': 'Rafraichir les contacts',
      'rafraichir_contacts_tooltip': "Permet de mettre à jour la liste des contacts du client à la suite d'une modification ou d'un ajout effectué dans Tolede.",
      'rafraichir_catalogue_tooltip': 'Permet de mettre à jour les modifications effectuées dans Tolede relatives aux articles et tarifs du client.',
      'affiche_dlc_modifie': "L'affichage des DLC a été modifié.",
      'affichage_dlc': 'Afficher les DLC',
      'affiche_produit_marche_modifie': "L'affichage du produit marché a été modifié.",
      'affichage_produit_marche': 'Afficher les Produits marché',
      'affiche_prix_ttc_modifie': "L'affichage des prix TTC a été modifié.",
      'affichage_prix_ttc': 'Afficher les prix TTC',
      'denomination_sociale': 'Dénomination sociale',
      'pas_de_contact': 'Pas de contact renseigné',
      'voir_tous_les_contacts': 'Voir tous les contacts',
      'adresse_precedente': 'Adresse précédente',
      'adresse_suivante': 'Adresse suivante',
      'cgv_tooltip': "Date d'acceptation des CGV",
      'profils_ub': 'Profils UB Essentielles',
      'profils_ub_description': 'Profils Unités de Besoins Essentielles associés au client.',
      'gerer_profils_ub': 'Gérer les profils UB',
      'profils_associes': '{{count}} profil associé',
      'profils_associes_one': '{{count}} profil associé',
      'profils_associes_other': '{{count}} profils associés',
      'aucun_profil_associe': 'Aucun profil associé',
      'aucun_profil_associe_description': 'Aucun profil UB Essentielles n\'est actuellement associé à ce client. Cliquez sur l\'icône d\'édition pour en associer.',
      'chargement_profils': 'Chargement des profils...',
      'aucun_profil_disponible': 'Aucun profil UB disponible',
      'nombre_items': '{{count}} item',
      'nombre_items_one': '{{count}} item',
      'nombre_items_other': '{{count}} items',
      'message': 'Message',
      'date': "Date de l'event",
      'telecharger': 'Payload',
      'identifiant_panier': 'Identifiant Panier',
      'statut_panier': 'Statut du panier',
      'quinze_derniers_jours': 'Sur les 15 derniers jours.',
      'validé': 'Validé',
      'erreur_inconnue': 'Erreur inconnue',
      'nombre_produits': 'Nombre de produits',
      'no_events': "Pas de validation ou d'échec de validation de panier sur les 30 derniers jours."
    },
    'prise_de_commande': {
      'liste_clients': {
        'title': 'Prise de commande',
        'reprendre_commande': 'Reprendre',
        'paniers': 'Paniers du commercial',
        'paniers_tooltip': 'Liste des paniers en cours créés par un commercial. Les paniers en cours du client sont visibles dans la fiche du client.',
        'nouveau_panier': 'Nouveau panier',
        'livraison_date': 'Livraison du {{date}}',
        'aucun_panier': 'Aucun panier',
        'profil': '{{count}} profil',
        'profil_one': '{{count}} profil',
        'profil_other': '{{count}} profils',
        'profil_many': '{{count}} profils',
        'profil_plural': '{{count}} profils',
        'article': '{{count}} article',
        'article_one': '{{count}} article',
        'article_other': '{{count}} articles',
        'article_many': '{{count}} articles',
        'article_plural': '{{count}} articles',
        'total_ht': 'Total HT : ',
        'derniere_maj': 'Dernière mise à jour le {{date}}',
        'derniere_commande': 'Dernière commande',
        'aucun_client': 'Aucun client trouvé',
        'tooltip_aucune_livraison': 'Aucune date de livraison disponible pour ce client.',
        'commande_commerciale': 'Commande commerciale',
        'aucune_date_disponible': 'Aucune date de livraison disponible pour ce client.',
        'actions': 'Actions',
        'actions_tooltip': 'Créer un nouveau panier pour votre client.',
        'panier_commercial_en_cours_tooltip': 'Panier commercial en cours',
        'commande_commercial_existante_tooltip': 'Commande commercial existante pour ce jour de livraison',
      },
      'panier': {
        'promotions': 'Promotions',
        'catalogue': 'Catalogue',
        'cadencier': 'Cadencier',
        'devis_personnalises': 'Devis personnalisés',
        'ub': 'UB Essentielles',
        'tout': 'Tout ({{count}})',
        'panier_vide': 'Le panier est vide !',
        'ajouter_articles_depuis': 'Ajouter des articles depuis :',
        'date_de_livraison': 'Date de livraison',
        'commander_autre_date': 'Commander pour une autre date',
        'adresse_de_livraison': 'Adresse de livraison',
        'changer_adresse': 'Changer l\'adresse de livraison',
        'reference_commande': 'Référence commande',
        'chargement_tooltip': 'Le chargement des données peut mettre quelques minutes.',
        'chargement_donnees': 'Chargement des données de votre client ...',
        'voir_fiche_client': 'Voir la fiche client',
        'differer_aussi_panier': 'Différer les produits du panier en cours',
        'erreur_chargement': 'Erreur lors du chargement des données du client.',
        'stock': 'Stock : {{count}} {{unite}}',
        'dlc_stock_sans_donnees': 'Pas de données DLC et de stock disponibles pour cet article.',
        'prix_total': 'Prix total',
        'prix_unite': 'Prix unité',
        'prix_saisi': 'Prix saisi',
        'reinitialiser_prix': 'Réinitialiser le prix',
        'prix_post_promo': 'Prix post promo : {{prix}} €',
        'prix_bloque': 'Intégrer à la dérogation',
        'prix_bloque_label': 'À intégrer à la déro',
        'marges_totales': 'VM <bold>{{vm}}</bold> / TM <bold>{{tm}}</bold> / MK <bold>{{mk}}</bold>',
        'marges': 'Marges',
        'prix_modifie_succes': 'Prix modifié avec succès',
        'ajout_rapide': 'Ajout rapide',
        'recherche_rapide': 'Rechercher un article...',
        'chargement_articles': 'Chargement des articles',
        'soit': 'Soit',
        'profils': 'Profils',
        'matching': 'Matching',
        'matching_titre': 'Rapport de matching',
        'matching_non_disponible': 'Rapport de matching non disponible',
        'pas_de_produits': 'Pas de produits',
        'ajouter_au_panier': 'Ajouter le produit',
        'ub_status': {
          'a-gagner': 'A gagner',
          'en-baisse': 'En baisse',
          'perdu': 'Perdue',
          'gagne': 'Gagnée',
          'ras': 'Stable',
        },
        'ub_status_nombre': {
          'a-gagner': '{{count}} à gagner',
          'en-baisse': '{{count}} en baisse',
          'perdu': '{{count}} perdue',
          'perdu_one': '{{count}} perdue',
          'perdu_many': '{{count}} perdues',
          'perdu_other': '{{count}} perdues',
          'perdu_plural': '{{count}} perdues',
          'gagne': '{{count}} gagnée',
          'gagne_one': '{{count}} gagnées',
          'gagne_many': '{{count}} gagnées',
          'gagne_other': '{{count}} gagnées',
          'gagne_plural': '{{count}} gagnées',
          'ras': '{{count}} stable',
          'ras_one': '{{count}} stable',
          'ras_many': '{{count}} stables',
          'ras_other': '{{count}} stables',
          'ras_plural': '{{count}} stables',
        },
        'ub_status_nombre_filtres': {
          'a-gagner': 'À gagner ({{count}})',
          'en-baisse': 'En baisse ({{count}})',
          'perdu': 'Perdue ({{count}})',
          'gagne': 'Gagnée ({{count}})',
          'ras': 'Stable ({{count}})',
        },
        'ub_tooltip': 'Les profils peuvent être modifiés depuis la fiche client.',
        'ub_section_regles': '<strong>Gagnée</strong> : L\'UB est gagnée si au moins un article de l’UB commandé une fois au cours des 30 derniers jours.<br/><strong>Perdue</strong> : L\'UB est perdue si aucun article commandé dans l’UB au cours des 30 derniers jours par rapport aux 30 jours d’avant.<br/><strong>En baisse</strong> : L\'UB est en baisse si la baisse de 30% du poids des articles de l’UB au cours des 30 derniers jours par rapport aux 30 jours d’avant.<br/><strong>À gagner</strong> : L\'UB est à gagner si aucun article de l’UB commandé au cours des 60 derniers jours.',
        'ub_section_tooltip': 'Sous-sous famille de la nomenclature :<br/> {{nom_famille}}',
        'confirmation_degradation_prix_metier': {
          'titre': 'Confirmer la dégradation du prix métier',
          'question': 'Êtes-vous sûr de vouloir dégrader le prix métier ?',
          'info': '<bold>Le prix métier est le prix plus intéressant</bold>, c\'est le prix appliqué selon la profession du client.',
          'annuler': 'Annuler',
          'degrader': 'Dégrader le prix',
        },
      },
      'confirmation': {
        'commande_confirmee': 'Commande confirmée !',
        'livraison_du': 'Livraison du {{date}}',
        'message_confirmation': 'Vous pouvez consulter le détail de la commande à tout moment dans la section "Mes commandes" de votre client.',
        'terminer': 'Terminer',
      },
      'drawer': {
        'ajouter_produits': 'Ajouter des produits',
        'choisir_categorie': 'Choisir une catégorie',
        'aucun_produit_disponible': 'Aucun produit disponible',
        'ajouter': 'Ajouter',
        'details_produit': 'Détails produit',
        'aucun_resultat_recherche': 'Aucun résultat pour la recherche',
        'fin_liste': 'Fin de la liste',
      },
      'aucune_societe_commerciale': 'Aucune société commerciale',
    },
    'conversations': {
      'titre': 'Conversations',
      'nouvelle_conversation': 'Nouvelle conversation',
      'initier_conversation': 'Créer une conversation',
      'commencer_conversation': 'Commencer la conversation',
      'client': 'Client',
      'rechercher_client_placeholder': 'Rechercher un client (min. 3 caractères)',
      'personne_a_contacter': 'Contact chez le client',
      'personne_a_contacter_chez': 'Contact chez {{raison_sociale}}',
      'selectionner_contact': 'Sélectionner un contact',
      'message': 'Message',
      'message_placeholder': 'Écrivez votre message...',
      'erreur_recherche_client': 'Erreur lors de la recherche',
      'aucun_client_trouve': 'Aucun client trouvé',
      'aucun_contact_disponible': 'Aucun contact disponible pour ce client',
      'erreur_creation': 'Erreur lors de la création de la conversation',
      'conversation_avec': 'Conversation avec {{raison_sociale}}',
      'chez': 'chez',
      'hier': 'Hier',
      'conversations_en_cours': 'conversation_one en cours',
      'conversations_en_cours_one': 'conversation en cours',
      'conversations_en_cours_other': 'conversations en cours',
      'aucune_conversation': 'Aucune conversation en cours.',
      'aucune_conversation_terminee': 'Aucune conversation terminée.',
      'selectionner_conversation': 'Sélectionnez une conversation',
      'sans_titre': 'Sans titre',
      'cloturer': 'Terminer la conversation',
      'aucun_message': 'Aucun message dans cette conversation.',
      'zone_saisie_placeholder': 'Zone de saisie (à venir)',
      'participant_commercial': '{{nom}} (commercial)',
      'placeholder_message': 'Tapez votre message',
      'conversation_terminee_info': 'Cette conversation a été terminée. Vous pouvez l\'ouvrir de nouveau en envoyant un message.',
      'envoyer': 'Envoyer',
      'ajouter_piece_jointe': 'Ajouter un document',
      'ajouter_image': 'Ajouter une image',
      'piece_jointe': 'Pièce jointe (optionnel)',
      'taille_fichier_ko': '{{taille}} Ko',
      'format_non_supporte': 'Le format du fichier "{{nom}}" n\'est pas supporté (formats acceptés : JPEG, PNG, GIF, WebP, PDF, Word, Excel)',
      'modifier_titre': 'Modifier le titre',
      'inviter_collaborateur': 'Inviter un collaborateur',
      'collaborateur': 'Collaborateur',
      'rechercher_collaborateur': 'Rechercher un collaborateur...',
      'aucun_collaborateur_trouve': 'Aucun collaborateur trouvé',
      'aucun_collaborateur_disponible': 'Aucun collaborateur disponible',
      'message_invitation': 'Message (optionnel)',
      'message_invitation_placeholder': 'Message personnalisé (optionnel)',
      'collaborateur_sans_email': 'Le collaborateur sélectionné ne possède pas d\'email enregistré. Il ne recevra pas d\'email d\'invitation.',
      'inviter': 'Inviter',
      'en_cours': 'En cours',
      'terminees': 'Terminées',
      'conversations_suivantes': 'Voir les conversations suivantes',
      'toutes_les_conversations': 'Toutes les conversations',
      'mes_conversations': 'Mes conversations',
      'conversations_terminees': 'Conversations terminées',
      'lecture_seule': 'Vous consultez cette conversation en lecture seule',
      'contact_inconnu': 'Contact inconnu',
      'contact_inconnu_tooltip': 'Ce contact n\'est plus rattaché à cette société',
      'utilisateur_inconnu': 'Utilisateur inconnu',
      'utilisateur_inconnu_tooltip': 'Ce collaborateur n\'est plus disponible',
      'rejoindre_conversation': 'Rejoindre la conversation',
      'vous_avez_rejoint': 'Vous avez rejoint la conversation',
    },
    'devis_personnalises': {
      'titre': 'Devis personnalisés',
      'mode_synako': 'Mode Synako',
      'mode_synako_demande': 'Mode demandes de dérogation',
      'mode_synako_injection': 'Mode injection de dérogation',
      'devis': 'Devis',
      'actions': 'Actions',
      'pas_de_devis_en_cours': 'Pas de devis en cours',
      'nouveau_devis': 'Nouveau devis',
      'modifie_le': 'Modifié le {{date}}',
      'aucun_client': 'Aucun client trouvé',
      'numero_devis': 'Devis {{numero}}',
      'devis_visible': 'Devis visible',
      'devis_masque': 'Devis masqué',
      'cree_le': 'Créé le {{date}}',
      'envoyer_message_client': 'Envoyer un message au client',
      'repondre': 'Répondre',
      'message_envoye_succes': 'Message envoyé avec succès',
      'message_requis': 'Le message est requis',
      'contact_destinataire_requis': 'Veuillez sélectionner un contact destinataire',
      'contact_destinataire': 'Contact destinataire',
      'choisir_contact': 'Choisir un contact...',
      'nouveau_message_client': 'Vous avez reçu {{count}} nouveau message de votre client',
      'nouveau_message_client_one': 'Vous avez reçu {{count}} nouveau message de votre client',
      'nouveau_message_client_other': 'Vous avez reçu {{count}} nouveaux messages de votre client',
      'voir': 'Voir',
      'client': 'Client',
      'message': 'Message',
      'placeholder_message': 'Saisissez votre message ici...',
      'caracteres': 'caractères',
      'tooltip_message_email': '- Un email sera envoyé :<br/>Bonjour,<br/>[Contenu de votre message]<br/>Bouton Consulter le devis<br/>Bien à vous,<br/>Votre signature<br/><br/>- [Contenu de votre message] sera affiché dans le devis de votre client côté FFConnect',
      'tooltip_message_email_demande_derogation': '- Un email sera envoyé :<br/>Bonjour,<br/>[Contenu de votre message]<br/>Bouton Consulter le devis<br/>Bien à vous,<br/>Votre signature<br/>',
      'historique': 'Historique',
      'historique_titre': 'Activité',
      'historique_tooltip': 'Voir l\'activité',
      'historique_onglet_tout': 'Tout',
      'historique_onglet_visibilite': 'Visibilité',
      'historique_onglet_articles': 'Articles',
      'historique_onglet_messages': 'Messages',
      'historique_onglet_derogations': 'Dérogations',
      'historique_tooltip_derogations': 'Demande ou validation des dérogations',
      'historique_aucun_evenement': 'Aucun événement dans cette catégorie',
      'nouveaux_messages': 'nouveau message',
      'nouveaux_messages_one': 'nouveau message',
      'nouveaux_messages_other': 'nouveaux messages',
      'historique_vierge': 'Aucun historique pour le moment',
      'evenement_fallback': 'Événement: {{type}}',
      'evenement_non_defini': 'Non défini',
      'derniere_consultation': 'Consulté par {{contact}}',
      'derniere_consultation_date': '{{date}}',
      'ajouter_produits': 'Plus de produits',
      'chargement_catalogue': 'Chargement du catalogue client en cours...',
      'demander_derogations': 'Demander les dérogations',
      'injecter_derogations': 'Valider les dérogations',
      'info_demande_derogation': 'Vous allez demander l\'approbation de {{nombreDerogations}} dérogation(s) pour le devis {{devisId}}.',
      'manager_destinataire': 'À :',
      'choisir_manager': 'Choisir un manager...',
      'saisir_email_manager': 'Saisir l\'email du manager',
      'message_explicatif': 'Message explicatif',
      'message_placeholder': 'Veuillez expliquer la raison de cette demande de dérogation...',
      'message_demande_derogation_defaut': 'Pouvez-vous valider ma demande de {{count}} dérogation ?',
      'message_demande_derogation_defaut_one': 'Pouvez-vous valider ma demande de {{count}} dérogation ?',
      'message_demande_derogation_defaut_many': 'Pouvez-vous valider mes demandes de {{count}} dérogations ?',
      'message_demande_derogation_defaut_other': 'Pouvez-vous valider mes demandes de {{count}} dérogations ?',
      'message_demande_derogation_defaut_plural': 'Pouvez-vous valider mes demandes de {{count}} dérogations ?',
      'nombre_derogations_a_injecter': '{{nombre}} dérogation(s) à injecter',
      'date_fin_validite': 'Date de fin de validité',
      'date_fin_validite_placeholder': 'Sélectionner une date',
      'marges_ligne': 'VM <bold>{{vm}}</bold> / TM <bold>{{tm}}</bold> / MK <bold>{{mk}}</bold>',
      'tooltip_marges': '<strong>VM (Valeur de Marge) :</strong> différence entre le prix catalogue et la base de marge (prix catalogue - base marge).<br/><strong>TM (Taux de Marge) :</strong> pourcentage de marge ((VM / base marge) × 100).<br/><strong>MK (Marge €/kg) :</strong> marge par kilogramme ((prix catalogue - base marge) / coefficient kg).',
      'date_fin_validite_aide': 'Les dérogations seront valides jusqu\'à cette date',
      'injection_non_disponible': 'Injection non disponible',
      'injection_non_disponible_raisons': 'L\'injection n\'est pas possible : soit vous n\'avez pas les permissions requises, soit il n\'y a pas de dérogations à injecter, soit le devis est archivé.',
      'derogations_injectees_succes': 'Dérogations injectées avec succès dans Tolède',
      'prix_en_cours_actualisation': 'Les prix sont en cours d\'actualisation',
      'refresh_catalogue': {
        'titre': 'Rafraîchissement du catalogue client',
        'message_principal': 'Nous mettons à jour le catalogue de votre client afin que les prix déro soient pris en compte. Cela peut prendre quelques minutes.',
        'info_fermeture': 'Si vous fermez cette modale, le catalogue continuera d\'être mis à jour et les changements seront visibles une fois la mise à jour terminée.',
        'succes_message': 'Le catalogue de votre client a été mis à jour avec succès. Les nouveaux prix avec dérogations sont maintenant disponibles.'
      },
      'envoyer_demande': 'Envoyer la demande',
      'envoi_en_cours': 'Envoi en cours...',
      'demande_derogation_envoyee': 'Demande de dérogation envoyée avec succès',
      'ajouter_au_devis': 'Ajouter au devis',
      'ajout_rapide': 'Ajout rapide',
      'recherche_rapide': 'Rechercher un article...',
      'article_ajoute_au_devis': 'L\'article a été ajouté au devis avec succès',
      'liste_produits': 'Liste de produits',
      'ajouter_une_note': '+ Ajouter une note',
      'ajouter_une_note_placeholder': 'Ajouter une note ...',
      'note_commerciale': 'Note du commercial',
      'pre_remplir_plus_produit': 'Pré-remplir avec le + du produit',
      'prix': '{{prix}} €HT/',
      'prix_dero_souhaite': 'Prix déro souhaité',
      'prix_dero_valide': 'Prix déro validé',
      'alerte_prix_plancher_depasse': '{{libelle}} ({{code_article}}) : le prix saisi ({{prix_saisi}} €HT) est inférieur au prix plancher ({{prix_plancher}} €HT)',
      'tarif_promotion': 'Promotion',
      'tarif_marche': 'Marché',
      'tarif_derogation': 'Dérogation',
      'tarif_general': 'Tarif général',
      'tarif_metier': 'Prix métier',
      'tarif_degagement': 'Dégagement',
      'tarif_prix_en_cours': 'Prix en cours',
      'tarif_non_precise': 'Non précisé',
      'tarif_non_precise_tooltip':
        "Tolede n'a pas transmis la catégorie de ce prix (tarif général, prix métier, dérogation…)",
      'aucun_tarif_disponible': 'Aucun tarif disponible',
      'panel_prix_titre': 'Prix',
      'panel_prix_categorie': 'Catégorie',
      'panel_prix_prix': 'Prix',
      'vider_le_devis': 'Vider le devis',
      'vider_devis_confirmation': 'Êtes-vous sûr de vouloir vider ce devis ? Cette action supprimera tous les produits du devis.',
      'derniere_maj': 'Dernière mise à jour le {{date}}',
      'devis_publie_succes': 'Le devis est maintenant visible par le client',
      'devis_depublie_succes': 'Le devis a été masqué pour le client',
      'devis_vide_succes': 'Le devis a été vidé avec succès',
      'archiver': 'Archiver',
      'tooltip_archiver': 'En archivant ce devis ne sera plus visible ni accessible.',
      'devis_archive_succes': 'Le devis a été archivé avec succès',
      'aucun_produit_ancien_devis': 'Aucun produit trouvé dans les anciens devis',
      'pas_encore_dans_tolede': 'Pas encore dans Tolède',
      'onglet_devis_personnalises_tooltip': 'Articles des devis non visibles',
      'tooltip_derogation_non_autorisée': 'Les dérogations ne sont pas autorisées pour cet article',
      'erreur_modification_prix_promotion': 'Les modifications de prix ne sont pas autorisées sur les promotions',
      'erreur_modification_prix_marche': 'Les modifications de prix ne sont pas autorisées sur les tarifs marché',
      'supprimer_prix_derogation': 'Supprimer le prix de dérogation saisi',
      'derogation_non_ajustable': 'Impossible de modifier le prix : dérogation non ajustable pour cet article',
      'dero_souhaitee_validee': 'Déro souhaitée validée',
      'dero_souhaitee_pas_encore_validee': 'Déro souhaitée pas encore validée',
      'prix_promo_actuel': 'Prix promo actuellement en cours : {{prix}} €',
      'pas_encore_devis_tolede': 'Pas encore un devis Tolede',
      'tooltip_pas_encore_devis': 'Pas encore un devis Tolede : le devis est injecté dans Tolede quand vous cliquez pour faire une demande de validation des dérogations souhaitées ou quand vous validez les dérogations ou quand vous rendez le devis visible.',
      'tooltip_numero_devis': 'Numéro de devis Tolede',
      'tooltip_numero_devis_avec_tolede': 'Numéro de devis Tolede : {{numero}}',
      'devis_sans_nom': 'Devis du {{date}}',
      'nom_du_devis': 'Nom du devis',
      'nom_modifie_succes': 'Le nom du devis a été modifié avec succès',
      'caracteres_restants': '{{count}} caractère restant',
      'caracteres_restants_one': '{{count}} caractère restant',
      'caracteres_restants_other': '{{count}} caractères restants',
      'tooltip_valider_derogations': 'En cliquant les déros souhaitées seront injectées dans Tolede.',
      'tooltip_demander_derogations': 'En cliquant vous pourrez demander à faire valider les déros souhaitées à votre responsable. Le devis sera également injecté dans Tolede.',
      'tooltip_injecter_tolede': 'Injecter le devis dans Tolede (les articles seront automatiquement ajoutés au cadencier du client).',
      'injecter_dans_tolede': 'Injecter dans Tolede',
      'devis_injecte_tolede_succes': 'Le devis a été injecté dans Tolede avec succès',
      'tooltip_devis_visibilite': '<strong>Devis visible activé :</strong> votre devis sera visible par le client depuis son compte France Frais Connect et les articles seront présents dans son Cadencier.<br/>Un seul devis peut être visible dans l\'espace FFConnect du client. Si vous avez un autre devis visible, il sera masqué en rendant ce devis visible.<br/><strong>Devis visible désactivé :</strong> votre devis n\'est pas visible par le client depuis son compte France Frais Connect.',
      'historique_evenements': {
        'devis_cree': 'Devis créé',
        'produit_avec_libelle_ajoute': 'Produit "{{codeArticle}}" {{libelle}} ajouté',
        'produit_ajoute': 'Produit "{{codeArticle}}" ajouté',
        'produit_ajoute_generique': 'Produit ajouté',
        'produit_avec_libelle_supprime': 'Produit "{{codeArticle}}" {{libelle}} supprimé',
        'produit_supprime': 'Produit "{{codeArticle}}" supprimé',
        'produit_supprime_generique': 'Produit supprimé',
        'devis_vide': 'Devis vidé',
        'note_modifiee_avec_libelle': 'Note modifiée pour "{{codeArticle}}" {{libelle}}',
        'note_modifiee': 'Note modifiée pour "{{codeArticle}}"',
        'note_modifiee_generique': 'Note modifiée',
        'prix_modifie_complet': 'Prix modifié pour "{{codeArticle}}" {{libelle}} : {{prixPrecedent}}€ → {{nouveauPrix}}€',
        'prix_modifie': 'Prix modifié pour "{{codeArticle}}"',
        'prix_modifie_generique': 'Prix modifié',
        'devis_publie': 'Devis visible',
        'devis_publie_par': 'Devis rendu visible par {{auteur_nom}}',
        'devis_depublie': 'Devis non visible',
        'devis_depublie_par': 'Devis masqué par {{auteur_nom}}',
        'devis_archive': 'Devis archivé',
        'message_commercial_envoye': 'Message envoyé par {{expediteur_nom}}',
        'message_commercial_avec_contenu': '{{expediteur_nom}} à {{destinataire_email}}',
        'message_commercial_envoye_generique': 'Message envoyé par le commercial',
        'commentaire_client_envoye': 'Commentaire envoyé par {{expediteur_nom}}',
        'commentaire_client_envoye_generique': 'Commentaire envoyé par le client',
        'message_client_recu': '{{expediteur_nom}}',
        'message_client_recu_generique': 'Message reçu du client',
        'derogations_demandees_complet_one': 'Demande de {{count}} dérogation envoyée par {{expediteur_nom}} à {{email_manager}}',
        'derogations_demandees_complet_other': 'Demande de {{count}} dérogations envoyée par {{expediteur_nom}} à {{email_manager}}',
        'derogations_demandees_par_one': 'Demande de {{count}} dérogation envoyée par {{expediteur_nom}}',
        'derogations_demandees_par_other': 'Demande de {{count}} dérogations envoyée par {{expediteur_nom}}',
        'derogations_demandees_generique_one': 'Demande de {{count}} dérogation envoyée',
        'derogations_demandees_generique_other': 'Demande de {{count}} dérogations envoyée',
        'derogations_injectees_par_one': 'Injection de {{count}} dérogation par {{injecte_par_nom}}',
        'derogations_injectees_par_other': 'Injection de {{count}} dérogations par {{injecte_par_nom}}',
        'derogations_injectees_generique_one': 'Injection de {{count}} dérogation',
        'derogations_injectees_generique_other': 'Injection de {{count}} dérogations',
        'devis_consulte_par': 'Devis consulté par {{contact}}',
        'devis_consulte': 'Devis consulté',
        'evenement_inconnu': 'Événement inconnu'
      },
    },
    'pdf_order_import': {
      'title': 'Import Commandes PDF',
      'nouvel_import': 'Nouvel import',
      'chercher_client': 'Chercher un client',
      'uniquement_echecs': 'Uniquement les échecs',
      'aucun_processus_trouve': 'Aucun processus trouvé',
      'recherche_client': 'Recherche de client',
      'placeholder_recherche_client': 'Entrez le nom ou code client (min. 3 caractères)',
      'chargement_societe': 'Chargement des données de la société...',
      'erreur_chargement_societe': 'Erreur lors du chargement des données de la société',
      'client_selectionne': 'Client sélectionné',
      'changer': 'Changer',
      'recherche': 'Recherche...',
      'erreur_recherche_clients': 'Erreur lors de la recherche de clients',
      'aucun_client_trouve': 'Aucun client trouvé',
      'id': 'ID',
      'fichier_pdf': 'Fichier PDF',
      'erreur_fichier_pdf': 'Le fichier doit être un PDF',
      'veuillez_selectionner_pdf': 'Veuillez sélectionner un fichier PDF',
      'fichier_invalide': 'Le fichier doit être de type {{types}}',
      'cliquez_ou_glissez_document': 'Cliquez ou glissez le document ici',
      'cliquez_ou_glissez_documents': 'Cliquez ou glissez le(s) document(s) ici',
      'formats_acceptes': '{{formats}}',
      'processus_initie_succes': 'Processus initié avec succès',
      'importer': 'Importer',
      'rapport': 'Rapport :',
      'voir_details': 'Voir les détails',
      'nom_fichier': 'Nom du fichier:',
      'taille_fichier': 'Taille du fichier:',
      'taille_fichier_ko': '{{taille}} ko',
      'reference_pdf': 'Référence du PDF:',
      'erreur_chargement_processus': 'Erreur lors du chargement du processus',
      'date_initiation': 'Date d\'initiation',
      'par': 'par {{utilisateur}}',
      'detail_processus': 'Détail du processus',
      'statut': 'Statut :',
      'cree_le': 'Créé le :',
      'mis_a_jour_le': 'Mis à jour le :',
      'modifier_panier': 'Aller au panier',
      'transformer_en_panier': 'Transformer en panier',
      'redemarrer_matching': 'Redémarrer le matching',
      'redemarrer_matching_avec_client': 'Redémarrer le matching avec ce client',
      'corriger_client': 'Corriger le client et redémarrer le matching',
      'erreur_detectee': 'Erreur détectée:',
      'etape_non_executee': 'Étape non encore exécutée',
      'voir_fichier_pdf': 'Voir le fichier PDF',
      'resultat_badge': {
        'ok': 'OK',
        'echec': 'Echec ({{nombre}}/{{total}})',
        'en_cours': 'En cours',
        'archive': 'Supprimé',
        'commande_validee': 'Commande validée',
        'panier': 'Panier',
        'non_defini': '-',
      },
      'etape': {
        'capture': 'Captation',
        'extract': 'Extraction',
        'match': 'Matching',
        'controle': 'Contrôle',
        'panier': 'Panier',
        'statut': {
          'terminee': 'OK',
          'echouee': 'KO',
          'en_cours': 'En cours',
          'non_defini': '-',
        },
      },
      'relancer_processus': 'Relancer le processus',
      'processus_relance_succes': 'Processus relancé avec succès',
      'processus_transforme_panier': 'Processus transformé en panier',
      'matching_redemarre_succes': 'Matching redémarré avec succès',
      'archiver_processus': 'Supprimer',
      'processus_archive_succes': 'Le processus a été supprimé',
      'archiver_confirmation': {
        'titre': 'Supprimer cet import ?',
        'texte':
          "L'import et son fichier PDF seront supprimés. Cette action est définitive.",
        'titre_avec_panier': 'Supprimer cet import et son panier ?',
        'texte_avec_panier':
          'Le panier créé à partir de cet import sera supprimé, avec toutes ses lignes. Cette action est définitive.',
        'valider_avec_panier': "Supprimer l'import et le panier",
      },
      'filtre': {
        'mes_imports': 'Mes imports',
        'initie_par': 'Initié par',
        'client': 'Client',
        'statut': 'Statut',
        'statut_en_cours': 'En cours',
        'statut_erreur': 'Erreur',
        'statut_panier': 'Panier',
        'statut_commande_validee': 'Commande validée',
      },
      'columns': {
        'date_reception_id': 'DATE DE RÉCEPTION / PDF',
        'lance_par': 'INITIÉ PAR',
        'client': 'CLIENT',
        'statut': 'STATUT',
      },
      'extract': {
        'erreur_plusieurs_commandes': 'Le PDF contient plusieurs dates de livraison différentes',
        'erreur_qualite_insuffisante': 'Le fichier PDF est de qualité insuffisante pour extraire les données',
        'erreur_annotations_manuscrites': 'Le PDF contient des annotations manuscrites',
        'erreur_pas_une_commande': 'Le document n\'est pas un bon de commande',
        'erreur_annulation_article': 'Le document est une demande d\'annulation',
        'erreur_demande_avoir': 'Le document est une demande d\'avoir',
        'erreur_aucune_ligne': 'Aucune ligne de produit n\'a été extraite du PDF',
        'voir_donnees_extraites': 'Voir les données extraites',
        'nom_client': 'Nom du client',
        'numero_client': 'Numéro client',
        'code_ur_client': 'Code UR',
        'siret_client': 'SIRET client',
        'date_de_livraison': 'Date de livraison',
        'adresse_de_livraison': 'Adresse de livraison',
        'numero_bon_commande': 'Référence commande',
        'date_creation': 'Date de création',
        'destinataire': 'Destinataire',
        'nombre_lignes': 'Nombre de lignes',
        'autres_informations': 'Autres informations',
        'non_renseigne': 'Non renseigné',
        'adresse_emetteur': 'Adresse émetteur',
        'adresse_facturation': 'Adresse de facturation',
        'contact_emetteur': 'Contact émetteur',
        'contact_adresse_livraison': 'Contact adresse de livraison',
        'contact_adresse_facturation': 'Contact adresse de facturation',
        'informations_de_livraison': 'Informations de livraison',
        'signature_client': 'Signature client',
        'prix_total': 'Prix total',
        'lignes': 'Lignes de produit',
        'nom': 'Nom',
        'prenom': 'Prénom',
        'email': 'Email',
        'telephone': 'Téléphone',
        'fonction': 'Fonction',
        'point_livraison_specifique': 'Point de livraison spécifique',
        'horaire_livraison_specifique': 'Horaire de livraison spécifique',
        'autres_informations_livraison': 'Autres informations de livraison',
        'nom_prenom': 'Nom et prénom',
        'date': 'Date',
        'total_ht': 'Total HT',
        'total_tva': 'Total TVA',
        'total_ttc': 'Total TTC',
        'numero_ligne_pdf': 'Numéro ligne PDF',
        'texte_entree': 'Texte original',
        'code_article_extrait': 'Code article',
        'libelle_extrait': 'Libellé',
        'quantite_commandee': 'Quantité',
        'coefficient_commande_client_vers_facturation': 'Coefficient',
        'unite_commande': 'Unité de commande',
        'unite_facturation': 'Unité de facturation',
        'prix_unitaire_extrait': 'Prix unitaire',
        'prix_total_extrait': 'Prix total',
        'marque_extraite': 'Marque',
        'exception_plusieurs_commandes': 'Plusieurs commandes',
        'exception_qualite_suffisante': 'Qualité suffisante',
        'exception_annotations_manuscrites': 'Annotations manuscrites',
        'exception_est_une_commande': 'Est une commande',
        'exception_annulation_article_commande_passee': 'Annulation article commande passée',
        'exception_demande_avoir': 'Demande d\'avoir',
        'exception_prix_total_incoherent': 'Prix total incohérent',
        'format_pdf': 'Format PDF',
        'confiance_metadata': 'métadonnées',
        'confiance_text': 'texte',
        'confiance_fallback': 'heuristique',
      },
      'match': {
        'exception': {
          'qualite_insuffisante': 'Le fichier PDF est de qualité insuffisante',
          'annotations_manuscrites': 'Le PDF contient des annotations manuscrites',
          'pas_une_commande': 'Le document n\'est pas un bon de commande',
          'demande_avoir': 'Le document est une demande d\'avoir',
          'annulation_commande': 'Le document est une demande d\'annulation',
          'plusieurs_commandes': 'Le PDF contient plusieurs dates de livraison',
          'aucune_ligne_extraite': 'Aucune ligne de produit n\'a été extraite',
          'prix_total_incoherent': 'Montant total des lignes différent du montant total.',
          'fichier_doublon': 'Fichier déjà traité le {{date_doublon}} à {{heure_doublon}}, initié par {{utilisateur_initiateur}}.',
          'fichier_doublon_lien': 'Voir le processus',
          'client_non_matche': 'Aucun client correspondant trouvé',
        },
        'exceptions_titre': 'Alertes et exceptions',
        'client_titre': 'Client',
        'client_code': 'Code client',
        'client_raison_sociale': 'Raison sociale',
        'date_de_livraison': 'Date de livraison',
        'date_extraite': 'Date extraite',
        'date_matchee': 'Date retenue',
        'date_valide': 'Date valide',
        'date_invalide': 'Date invalide',
        'date_livraison.validee': 'Date de livraison extraite et validée',
        'date_livraison.aucune_tournee_correspond': 'Aucune tournée ne correspond à la date de livraison indiquée par le client.',
        'date_livraison.date_inferieure_aujourdhui': 'La date de livraison indiquée par le client est inférieure à la date du jour',
        'date_livraison.absente': 'Aucune date de livraison sur le bon de commande : la première tournée disponible a été retenue.',
        'adresse_de_livraison': 'Adresse de livraison',
        'adresse_extraite': 'Adresse extraite',
        'adresse_matchee': 'Adresse identifiée',
        'aucune_adresse_matchee': 'Aucune adresse identifiée',
        'mode_unique': 'Adresse unique client',
        'mode_bm25': 'Correspondance BM25',
        'mode_default': 'Sélection par défaut',
        'adresse_non_verifiee': 'Adresse non vérifiée - correspondance faible',
        'etat_badge_ok': 'OK',
        'etat_badge_alerte': 'À vérifier',
        'etat_badge_bloquant': 'À vérifier en priorité',
        'adresse_ok': 'Adresse validée',
        'adresse_alerte': 'Adresse à vérifier',
        'adresse_bloquant': 'Adresse à valider dans Tolède',
        'statistiques': 'Statistiques',
        'lignes_ok': 'Lignes OK',
        'lignes_avertissement': 'À vérifier',
        'lignes_bloquant': 'À vérifier en priorité',
        'lignes': 'Lignes de commande',
        'aucune_ligne': 'Aucune ligne',
        'code_deduit': 'Code déduit',
        'code_exact': 'Code identique',
        'libelle_different': 'Libellé différent',
        'quantite_incoherente': 'Quantité incohérente',
        'quantite_incoherente_detail': 'Multiple: {{multiple}}, quantité PDF: {{quantite_pdf}}',
        'quantite_ajustee_suggestion': 'Suggéré: {{quantite_ajustee}}',
        'prix_different': 'Prix différent ({{ecart}}%)',
        'unite_incoherente': 'Unité incohérente',
        'unite_incoherente_detail': '{{unite_pdf}} → {{unite_catalogue}}',
        'unite_inconnue': 'Inconnue',
        'unite_raison_incompatible_units': 'Unités incompatibles',
        'unite_raison_unknown_unit': 'Unité non reconnue dans le PDF',
        'unite_raison_regle_de_trois_ok': 'Accepté (règle de trois OK)',
        'hors_cadencier': 'Hors cadencier',
        'dans_cadencier': 'Dans le cadencier',
        'article_non_trouve': 'Article non trouvé',
        'donnees_pdf': 'Données PDF',
        'prix_pdf': 'Prix PDF',
        'prix_catalogue': 'Prix catalogue',
        'libelle_pdf': 'Libellé PDF',
        'libelle_catalogue': 'Libellé catalogue',
        'similarite': 'Similarité',
        'faible_similarite': 'Faible similarité',
        'comparaison_libelle': 'Comparaison du libellé',
        'score_tooltip': 'Confiance: {{score}}%',
        'nombre_lignes_coherent': 'Nombre de lignes cohérent',
        'nombre_lignes_coherent_tooltip': 'PDF: {{pdf}}, Extraites: {{extraites}}',
        'nombre_lignes_incoherent': 'PDF: {{pdf}}, Extraites: {{extraites}}',
        'prix_total_titre': 'Prix total',
        'prix_total_pdf': 'Prix PDF (HT)',
        'prix_total_pdf_ttc': 'Prix PDF (TTC)',
        'prix_total_calcule': 'Prix calculé',
        'prix_total_coherent': 'Montants cohérents',
        'prix_total_incoherent': 'Écart de {{ecart}}%',
        'voir_comparaison_detaillee': 'Voir la comparaison détaillée des données',
        'colonne_champ': 'Champ',
        'colonne_valeur_pdf': 'Valeur PDF',
        'colonne_valeur_matchee': 'Déduction',
        'colonne_statut': 'Résultat',
        'champ_texte_entree': 'Information brute',
        'champ_code_article': 'Code article',
        'champ_libelle': 'Libellé',
        'champ_unite_commande': 'Unité de commande',
        'champ_unite_facturation': 'Unité de facturation',
        'champ_quantite': 'Quantité',
        'champ_prix_unitaire': 'Prix unitaire',
        'champ_prix_total': 'Prix total',
        'champ_cadencier': 'Au Cadencier',
        'code_article_client_info': 'Code client : {{code}}',
        'code_generique_info': 'Code générique : {{code}}',
        'quantite_multiple_info': 'Multiple de commande : {{multiple}}',
        'ligne_colonne_numero': 'N°',
        'ligne_colonne_code': 'Code',
        'ligne_colonne_libelle': 'Libellé',
        'ligne_colonne_qte': 'Qté',
        'ligne_colonne_prix_u': 'Prix U',
        'ligne_colonne_prix_ligne': 'Prix Ligne',
        'badge_code': 'Code',
        'badge_code_exact': 'Exact',
        'badge_code_non_trouve': 'Non trouvé',
        'badge_code_manquant': 'Manquant',
        'badge_libelle': 'Libellé',
        'badge_libelle_exact': 'Exact',
        'badge_libelle_partiel': 'Partiel',
        'badge_libelle_non_reconnu': 'Non reconnu',
        'badge_prix_ligne': 'Prix ligne',
        'badge_prix_ligne_ok': 'OK',
        'badge_prix_ligne_alerte': 'Alerte',
        'badge_prix_ligne_ko': 'Incohérent',
        'badge_prix_unitaire': 'Prix unitaire',
        'badge_dans_cadencier': 'Dans le cadencier',
        'badge_hors_cadencier': 'Hors cadencier',
        'tooltip_similarite': 'Similarité : {{score}}%',
        'tooltip_ecart': 'Écart : {{ecart}}%',
        'tooltip': {
          'etat_final': 'État final: {{etat}}',
          'identification': 'Identification: {{etat}}',
          'code_detail': '• Code: {{etat}} {{valeur}}',
          'libelle_detail': '• Libellé: {{etat}}',
          'prix_ligne_detail': 'Prix ligne: {{etat}}',
          'etat': {
            'ok': 'OK',
            'alerte': 'ALERTE',
            'bloquant': 'BLOQUANT',
          },
          'code': {
            'exact': 'EXACT',
            'non_trouve': 'NON TROUVÉ',
            'manquant': 'MANQUANT',
          },
          'libelle': {
            'exact': 'EXACT ({{percentage}}%)',
            'partiel': 'PARTIEL ({{percentage}}%)',
            'non_reconnu': 'NON RECONNU ({{percentage}}%)',
          },
          'prix': {
            'ok': 'OK',
            'alerte': 'ALERTE ({{ecart}})',
            'ko': 'KO ({{ecart}})',
            'vide': 'Aucun prix à comparer',
          },
          'regle': {
            'prix_absent': 'Aucun prix à comparer → ALERTE',
            'prix_bloquant': 'Prix ligne > {{threshold}}% → BLOQUANT',
            'code_exact_libelle_ok': 'Code EXACT + Libellé OK → OK',
            'code_exact_libelle_ko': 'Code EXACT + Libellé KO → BLOQUANT (conflit suspect)',
            'libelle_exact_compense_code': 'Libellé EXACT compense l\'absence de code → OK',
            'pas_code_libelle_partiel': 'Pas de code + Libellé PARTIEL → ALERTE',
            'ni_code_ni_libelle': 'Ni code ni libellé fiable → BLOQUANT',
            'prix_alerte': 'Prix ligne ≤ {{threshold}}% → ALERTE',
            'evaluation_standard': 'Évaluation standard',
          },
        },
        'client_mode_auto': 'Détection automatique',
        'client_mode_preselectionne': 'Présélectionné',
        'client_confiance': 'Confiance',
        'client_donnees_extraites': 'Données extraites du PDF',
        'client_donnees_matchees': 'Client identifié',
        'client_siret': 'SIRET',
        'client_numero': 'Numéro client',
        'client_nom': 'Nom client',
        'client_adresse_livraison': 'Adresse de livraison',
        'client_adresse_facturation': 'Adresse de facturation',
        'client_etapes_matching': 'Étapes du matching',
        'client_candidats': 'Candidats',
        'client_candidats_restants': '{{count}} candidat(s)',
        'client_candidats_partial': 'Candidats ({{displayed}} sur {{total}})',
        'client_candidats_all': 'Candidats ({{total}})',
        'client_score': 'Score',
        'client_criteres': 'Critères matchés',
        'client_non_renseigne': 'Non renseigné',
        'client_valeur_recherchee': 'Valeur recherchée',
        'critere_utilise': {
          'siret': 'SIRET',
          'code_client': 'Code client',
          'adresses_livraison_facturation': 'Adresses livraison/facturation',
          'raison_sociale': 'Raison sociale',
          'code_client_suffixe': 'Code client (suffixe)'
        },
        'critere_match': {
          'siret_exact': 'SIRET exact',
          'numero_client_exact': 'Numéro client exact',
          'adresse_bm25': 'Adresse',
          'nom_bm25': 'Nom',
          'code_client_suffixe': 'Code client suffixe',
        },
        'client_bloque': 'Client bloqué',
      },
    },
    'menu': {
      'clients': 'Clients',
      'commandes': 'Commandes',
      'catalogue_grand_compte': 'Catalogue France Frais',
      'operations_commerciales': 'Opérations commerciales',
      'commandes_pdf': 'Commandes PDF',
      'changelog': 'Changelog',
      'roadmap': 'Roadmap',
      'devis': 'Devis',
      'maintenance': 'Maintenance',
      'conversations': 'Conversations',
      'administration_fonctionnalites': 'Accès aux fonctionnalités',
      'retour_accueil': 'Retour à la liste des sociétés',
    },
    'administration_fonctionnalites': {
      'delai_cache': 'Les changements sont pris en compte sous une minute.',
      'acces_refuse': 'Vous n’avez pas accès à cette page.',
      'succes': 'Modification enregistrée',
      'clients_actionnaires': {
        'titre': 'Clients actionnaires',
        'description':
          'Paramétré en semaine paire ou impaire. Importez le fichier Excel (colonnes Code Tolède et SEMAINE LIVRAISON) pour remplacer entièrement la liste.',
        'format_excel': 'Format de l’Excel attendu',
        'compteur_one': '{{count}} client paramétré',
        'compteur_other': '{{count}} clients paramétrés',
        'compteur_plural': '{{count}} clients paramétrés',
        'importer': 'Importer le fichier Excel',
        'succes':
          'Import terminé : {{count}} ligne(s) appliquée(s), {{inconnus}} code(s) inconnu(s), {{invalides}} ligne(s) rejetée(s).',
      },
      'ajouter': 'Ajouter',
      'aucun_email': 'Aucun email',
      'aucun_resultat': 'Aucun résultat pour « {{recherche}} »',
      'recherche_email_placeholder': 'Rechercher un email…',
      'compteur_emails_one': '{{count}} email',
      'compteur_emails_other': '{{count}} emails',
      'compteur_emails_plural': '{{count}} emails',
      'supprimer_email': 'Supprimer l’email',
      'email_placeholder': 'email@exemple.fr',
      'actif': 'Activé',
      'inactif': 'Désactivé',
      'toutes_les_societes': 'Toutes les sociétés',
      'aucune_societe': 'Aucune société',
      'ajouter_societes': 'Ajouter des sociétés',
      'supprimer_societe': 'Retirer la société',
      'ou': 'OU',
      'actif_pour_tous': 'Activé pour tout le monde',
      'societes_autorisees': 'Sociétés autorisées',
      'utilisateurs_autorises': 'Utilisateurs autorisés',
      'utilisateurs_operations_nationales': 'Utilisateurs des opérations nationales',
      'administrer_utilisateurs': 'Administrer les utilisateurs de la fonctionnalité',
      'phrase_utilisateurs': 'Cette liste n’est modifiable que si « Activé pour tout le monde » est désactivé.',
      'zones': {
        'deploiement': 'Déploiement',
        'administrateurs': 'Administrateurs',
        'delegues': 'Qui peut gérer les accès',
      },
      'categories': {
        'operations_commerciales': 'Opérations commerciales',
        'commandes_pdf': 'Commandes PDF',
        'prise_de_commande': 'Prise de commande',
        'mode_commercial': 'Mode commercial',
        'devis_tarifaires': 'Devis tarifaires',
        'ub_essentielles': 'UB essentielles',
        'conversations': 'Conversations',
        'egalim': 'Egalim',
        'roadmap': 'Roadmap',
        'maintenance': 'Maintenance',
        'sandbox': 'Accès à la SBX',
        'tolede': 'Tolède',
      },
      'cles': {
        'operation_commerciale_test_users': 'Emails de test',
        'operation_commerciale_nationale_authorized_users': 'Administrateurs des opérations nationales',
        'operation_commerciale_enable': 'Activé pour tout le monde',
        'societe_commerciale_operation_commerciale_autorisee': 'Sociétés autorisées',
        'pdf_order_import_test_users': 'Emails de test',
        'pdf_order_import_enabled': 'Activé pour tout le monde',
        'prise_de_commande_test_users': 'Emails de test',
        'prise_de_commande_enable': 'Activé pour tout le monde',
        'societe_commerciale_prise_de_commande_autorisee': 'Sociétés autorisées',
        'mode_commercial_test_users': 'Emails de test',
        'mode_commercial_enable': 'Activé pour tout le monde',
        'societe_commerciale_mode_commercial_autorisee': 'Sociétés autorisées',
        'devis_tarifaires_test_users': 'Emails de test',
        'devis_tarifaires_enable': 'Activé pour tout le monde',
        'societe_commerciale_devis_tarifaires_autorisee': 'Sociétés autorisées',
        'ub_essentielles_test_users': 'Emails de test',
        'ub_essentielles_enable': 'Activé pour tout le monde',
        'societe_commerciale_ub_essentielles_autorisee': 'Sociétés autorisées',
        'conversations_test_users': 'Emails de test',
        'conversations_enable': 'Activé pour tout le monde',
        'conversations_toutes_enable': 'Accès à toutes les conversations',
        'societe_commerciale_conversations_autorisee': 'Sociétés autorisées',
        'egalim_test_users': 'Emails de test',
        'egalim_enable': 'Activé pour tout le monde',
        'societe_commerciale_egalim_autorisee': 'Sociétés autorisées',
        'roadmap_authorized_users': 'Emails autorisés',
        'maintenance_authorized_users': 'Emails autorisés',
        'sbx_authorized_users': 'Emails autorisés',
        'tolede_authorized_users': 'Emails autorisés en safelive',
        'tolede_unauthorized_users': 'Emails exclus en mode normal',
        'delegues': 'Qui peut gérer les accès',
      },
    },
    'operations_commerciales': {
      'succee_dupliquer': 'Opération commerciale dupliquée avec succès',
      'succee_modifier': 'Opération commerciale modifiée avec succès',
      'succee_archiver': 'Opération commerciale archivée avec succès',
      'ajouter_article': 'Ajouter des articles',
      'article_ajoute': 'Article ajouté avec succès',
      'erreur_ajout': 'Erreur lors de l\'ajout de l\'article',
      'article_obsolete': 'Obsolète',
      'article_reserve': 'Réservé à {{codes}}',
      'article_reserve_hors_beneficiaires': 'Aucune filiale bénéficiaire de l\'opération ne figure parmi les sociétés auxquelles cet article est réservé',
      'buttons': {
        'creer': 'Nouvelle opération',
        'publier': 'Publier',
        'archiver': 'Archiver',
        'ajouter_article': 'Ajouter',
        'deja_ajoute': 'Produit ajouté',
      },
      'creation': {
        'succee' : 'Opération créée avec succès',
        'erreur_info': 'Erreur lors de la création de l\'opération commerciale',
      },
      'modification': {
        'chargement': 'Chargement des informations de l\'opération commerciale',
        'lecture_seule_nationale': 'Opération nationale : vous la consultez en lecture seule. Sa modification est réservée aux personnes autorisées.',
        'lecture_seule': 'Vous consultez cette opération en lecture seule.',
        'lecture_seule_archivee': 'Opération archivée : elle se consulte en lecture seule. Dupliquez-la pour la réutiliser.',
        'sauvegarde_automatique': 'Modifications automatiquement sauvegardées',
      },
      'modale_filiales': {
        'titre': 'Ajouter des filiales',
        'rechercher': 'Rechercher une filiale…',
        'disponibles': 'Filiales disponibles',
        'toutes': 'Toutes',
        'toutes_info': 'Cocher toutes les filiales affichées',
        'nombre_disponibles_one': '{{count}} filiale',
        'nombre_disponibles_other': '{{count}} filiales',
        'nombre_selectionnees_one': '{{count}} filiale sélectionnée',
        'nombre_selectionnees_other': '{{count}} filiales sélectionnées',
        'aucun_resultat': 'Aucune filiale ne correspond à votre recherche.',
      },
      'modale_langues': {
        'titre': 'Ajouter une langue',
      },
      'modale_couleur': {
        'titre': 'Choisir une couleur',
        'appliquer': 'Appliquer',
        'palette': 'Couleurs de la palette',
        'hex_label': '#',
        'rouge_label': 'R',
        'vert_label': 'G',
        'bleu_label': 'B',
        'hex_aria': 'Code hexadécimal de la couleur',
        'rouge_aria': 'Composante rouge, de 0 à 255',
        'vert_aria': 'Composante verte, de 0 à 255',
        'bleu_aria': 'Composante bleue, de 0 à 255',
      },
      'modale_cadrage': {
        'titre': 'Ajuster le cadrage des images',
        'enregistrer': 'Enregistrer',
        'tourner_gauche': "Tourner l'image d'un quart de tour vers la gauche",
        'tourner_droite': "Tourner l'image d'un quart de tour vers la droite",
        'erreur_chargement':
          "L'image n'a pas pu être chargée : ce volet gardera son cadrage actuel.",
        'aria_zone':
          'Zone de cadrage : flèches du clavier pour la déplacer',
        'aria_poignee_nw':
          'Poignée en haut à gauche : flèches du clavier pour redimensionner',
        'aria_poignee_ne':
          'Poignée en haut à droite : flèches du clavier pour redimensionner',
        'aria_poignee_se':
          'Poignée en bas à droite : flèches du clavier pour redimensionner',
        'aria_poignee_sw':
          'Poignée en bas à gauche : flèches du clavier pour redimensionner',
      },
      'modale_sous_metiers': {
        'titre': 'Sous-métiers de {{metier}}',
        'nombre_selectionnes_one': '{{count}} sous-métier sélectionné',
        'nombre_selectionnes_other': '{{count}} sous-métiers sélectionnés',
      },
      'langue': {
        'fr': 'Français',
        'en': 'Anglais',
        'de': 'Allemand',
      },
      'portee': {
        'locale': 'Locale',
        'nationale': 'Nationale',
      },
      'modale_portee': {
        'titre': 'Nouvelle opération commerciale',
        'locale_description': 'Modifiable par toutes les filiales bénéficiaires.',
        'nationale_description': 'Modifiable uniquement par les personnes autorisées. Les filiales bénéficiaires la voient en lecture seule.',
        'info': 'La portée ne pourra plus être modifiée ensuite.',
        'creer': 'Créer',
      },
      'modale_archivage': {
        'titre': 'Archiver l\'opération',
        'message': 'L\'opération ne sera plus affichée aux clients et ne pourra pas être désarchivée. Pendant un an, elle reste visible dans la liste avec « Voir les opérations archivées » et peut être dupliquée.',
      },
      'form_info': {
        'operation_info': 'À propos de l\'opération',
        'nom_label' : 'Nom de l\'opération',
        'nom_placeholder' : 'Nom de l\'opération',
        'description_label': 'Description de l\'opération',
        'description_placeholder': 'Décrivez l\'opération en quelque mots',
        'banniere_label': 'Bannière',
        'banniere_info_text_part1': 'L\'image doit provenir de la bibliothèque média France Frais accessible',
        'banniere_info_text_link': 'ici',
        'banniere_info_tooltip': 'Si vous n\'avez pas accès à la bibliothèque média, vous pouvez en faire la demande à {{email}}',
        'visuels_label': 'Visuels de l\'opération',
        'ordre_label': 'Ordre d\'affichage',
        'metier_label': 'Métiers',
        'visibilite_label': 'Visibilité',
        'ciblage_label': 'Ciblage',
        'filiales_label': 'Filiale bénéficiant de l\'opération',
        'filiales_info': 'Les clients de chaque filiale sélectionnée voient l\'opération. Seules les filiales de votre périmètre sont proposées.',
        'filiale_hors_perimetre': 'Filiale hors de votre périmètre, vous ne pouvez pas la retirer.',
        'filiale_retirer': 'Retirer la filiale',
        'filiale_derniere': 'Une opération doit bénéficier à au moins une filiale.',
        'ajouter_filiale': 'Ajouter une filiale',
        'voir_toutes_les_filiales': 'Voir toutes les filiales ({{count}})',
        'sous_metier_label': 'Sous-métiers ciblés',
        'sous_metier_info': 'Sans sous-métier sélectionné, l\'opération cible le métier entier. Avec, elle ne cible que les sous-métiers choisis.',
        'ajouter_sous_metier': 'Ajouter un sous-métier',
        'article_liste_label': 'Liste de produits',
        'ajouter_produits': 'Ajouter des produits',
        'ajouter_produits_directement': 'Ajouter des produits directement',
        'aucun_produit': 'Pas encore de produit',
        'traduction_label': 'Traduction',
        'ajouter_langue': 'Ajouter une langue',
        'article_deja_present': 'L\'article \'{{code_article}}\' a déjà été ajouté',
        'article_inexistant': 'l\'article \'{{code_article}}\' n\'existe pas',
        'apercu_label': 'Aperçu',
        'apercu_ordinateur': 'Ordinateur',
        'apercu_mobile': 'Mobile',
        'ajuster_cadrage': 'Ajuster le cadrage des images',
        'reinitialiser_cadrage': 'Réinitialiser le cadrage',
        'compteur_caracteres': '{{longueur}}/{{max_length}}',
        'langue_retirer': 'Retirer la langue',
        'image_ordinateur': 'Image ordinateur',
        'image_mobile': 'Image mobile',
        'format_recommande': 'Format recommandé : 1920×1080 px JPG, PNG, WEBP • Max 5 Mo',
        'glisser_ou_importer': 'Glissez ou importez votre image ici',
        'couleur_banniere_label': 'Sélectionner la couleur de la bannière',
        'choisir_couleur': 'Couleur {{couleur}}',
        'ajouter_couleur': 'Choisir une autre couleur',
        'remplacer_image': 'Remplacer',
        'retirer_image': 'Retirer l\'image',
        'envoi_image_en_cours': 'Envoi de l\'image en cours...',
        'plage_date_label': 'Période',
        'selectionner_periode': 'Sélectionner une période',
        'plage_date_info': 'La période d’affichage de l’opération aux clients. Sans période, l’opération n’est pas affichée.',
        'affiche_date_fin_label': 'Afficher la date de fin de l\'opération au client',
      },
      'columns': {
        'nom': 'Opération',
        'ordre': 'Ordre',
        'statut': 'Statut',
        'statut_info': {
          'visible': 'Visible : dans sa période, l’opération est affichée aux clients ciblés.',
          'masquee': 'Masquée : sans période, ou en dehors de sa période (passée ou à venir), elle n’est affichée à aucun client.',
          'archivee': 'Archivée : elle n’est affichée à aucun client et ne se modifie plus, mais peut être dupliquée. Elle quitte la liste un an après son archivage.',
        },
        'portee': 'Portée',
        'portee_info': 'Nationale : modifiable uniquement par les personnes autorisées, les filiales bénéficiaires la voient en lecture seule. Locale : modifiable par toutes les filiales bénéficiaires.',
        'articles': 'Articles',
        'destinataires': 'Destinataires',
        'actions': 'Actions',
        'plage_date': 'Période',
      },
      'statut': {
        'publiee': 'Visible',
        'depubliee': 'Masquée',
        'archivee': 'Archivée',
      },
      'chercher_operation': 'Chercher une opération…',
      'effacer_recherche': 'Effacer la recherche',
      'aucune_operation': 'Aucune opération commerciale à afficher.',
      'voir_archivees': 'Voir les opérations archivées',
      'nombre_metiers': '{{count}} métier',
      'nombre_metiers_one': '{{count}} métier',
      'nombre_metiers_other': '{{count}} métiers',
      'aucun_metier': 'Aucun métier',
      'sous_metiers_du_metier': '{{metier}} : {{sous_metiers}}',
      'articles': {
        'un': '{{nb_produits}} article ',
        'plusieurs': '{{nb_produits}} articles',
      },
      'actions': {
        'publier': 'Publier',
        'dupliquer': 'Dupliquer',
        'archiver': 'Archiver',
        'erreur_info': 'Erreur lors de l\'action: {{scope}}'
      },
      'plage_date_courte': '{{date_debut}} - {{date_fin}}',
    },
    'pdf_import': {
      'status': {
        'searching': 'Recherche...',
        'matched_ok': 'Trouvé',
        'not_found': 'Non trouvé dans le catalogue',
        'error': 'Erreur lors de la recherche',
      },
      'mismatch': {
        'code': 'Code article différent du catalogue',
        'name': 'Libellé différente du catalogue',
      },
      'table': {
        'status': 'Statut',
        'catalog_code': 'Code Catalogue',
        'catalog_name': 'Désignation Catalogue',
        'pdf_code': 'Code (extrait du PDF)',
        'pdf_name': 'Libellé (extrait du PDF)',
        'pdf_qty': 'Qté (extrait du PDF)',
        'pdf_unit': 'Unité (extrait du PDF)',
        'pdf_unit_price': 'PU (extrait du PDF)',
      },
      'success_parse': 'PDF analysé avec succès',
      'error_invalid_type': 'Format de fichier invalide',
      'error_no_file': 'Aucun fichier sélectionné',
      'error_client_not_ready': 'Client non sélectionné',
      'parsing_pdf': 'Analyse du PDF en cours ...',
      'title': 'Importer une commande PDF',

      'no_clients_available': 'Aucun client disponible',
      'select_client_placeholder': 'Sélectionner un client...',
      'no_clients_found': 'Aucun client trouvé',
      'error_fetching_clients': 'Erreur lors de la récupération des clients',
      
      'file_label': 'Fichier PDF de la commande',
      'effacer_fichier': 'Effacer le fichier',
      'submit_button': 'Analyser le PDF',
      'error_submission': "Erreur lors de l'analyse du PDF.",
      'error_loading_index': 'Erreur lors du chargement du catalogue client.',
      'loading_index': "Chargement de l'index de recherche...",
      'searching_items': 'Recherche des articles...',
      'results_title': "Résultats de l'analyse PDF",
      'delivery_date': 'Date de livraison',
      'delivery_address': 'Adresse de livraison',
      'order_reference': 'Référence commande',
      'import_another': 'Importer un autre fichier',
      'export_xlsx': 'Exporter en tableau',
      'search_client_label': 'Rechercher un client',
    },
    'roadmap': {
      'toast': {
        'success': 'La roadmap a été mise à jour',
      },
      'acceder': 'Accéder à la Roadmap FFConnect / FFCommerce',
      'acces_refuse': 'Accès réservé au groupe projet FFConnect.',
      'vide': 'Aucune roadmap publiée pour le moment.',
      'edition_titre': 'Modifier la roadmap',
      'edition_aide':
        'Collez ci-dessous le code HTML complet de la roadmap. Il remplacera intégralement le contenu actuel.',
      'placeholder': 'Collez ici le code HTML de la roadmap…',
      'enregistrer': 'Enregistrer',
    },
    'changelog': {
      'titleForm': 'Changelog FFConnect',
      'toast': {
        'success': 'Le changelog a été créé avec succès'
      },
      'form': {
        'title': 'Titre',
        'placeholder_title': 'Ex: Nouveautés FFConnect',
        'article_id': 'ID de l\'article',
        'date': 'Date',
        'enregister': 'Enregistrer',
      },
    },
  },
  'metier': {
    'A1': 'RESTAURATION SOCIALE',
    'A2': 'RESTAURATION COMMERCIALE',
    'A3': 'A REAFFECTER B1 B2 B3 A2',
    'A4': 'GMS',
    'A5': 'FILIALES / PERSONNEL',
    'A6': 'GROSSISTES INDUSTRIELS',
    'A7': 'PROXI',
    'B1': 'BVP',
    'B2': 'CREMIERS',
    'B3': 'BOUCHER CHARCUTIER TRAITEUR',
    'B4': 'AUTRES ARTISANS COMMERCANTS',
    'E1': 'EXPORT A RECLASSER',
    'P1': 'PARTICULIERS'
  },
  'sous_metier': {
    'A1-11': 'Entreprise',
    'A1-12': 'Scolaire',
    'A1-13': 'Santé',
    'A1-14': 'Social',
    'A1-15': 'Loisir',
    'A1-16': 'Divers',
    'A2-21': 'Service à table',
    'A2-22': 'Cafétéria',
    'A2-23': 'Restauration rapide',
    'A2-24': 'Hôtel',
    'A2-25': 'Restauration de transport',
    'A2-26': 'Restauration de loisir',
    'A2-27': 'Traiteur réception (sans boutique)',
    'A2-28': 'Marketplace',
    'A4-41': 'Proximité',
    'A4-42': 'GMS',
    'A4-49': 'Multi-frais',
    'A4-50': 'Vente en ligne',
    'A5-51': 'Vente au personnel France Frais',
    'A5-52': 'Filiales',
    'A6-61': 'Grossistes',
    'A6-62': 'Industriels',
    'A6-63': 'Méthaniseur / destructeur',
    'A6-64': 'Transporteurs',
    'A7-1': 'Enseigne GMS',
    'A7-2': 'Supérette / épicerie indépendante',
    'B1-71': 'Boulanger-pâtissier',
    'B1-72': 'Boulanger',
    'B1-73': 'Pâtissier',
    'B1-74': 'Glacier',
    'B1-75': 'Terminaux de cuisson',
    'B1-76': 'Chocolatier',
    'B1-77': 'Labo GMS',
    'B2-81': 'Crémiers',
    'B2-82': 'Vente en ligne',
    'B3-91': 'Bouchers',
    'B3-94': 'Vente en ligne',
    'B3-96': 'Volailler / triperie',
    'B3-97': 'Boucherie chevaline',
    'B3-98': 'Charcutier / traiteur boutique',
    'B3-99': 'Rôtisserie',
    'B4-91': 'Épicerie fine',
    'B4-92': 'Autres (brasseur, torréfacteur…)',
    'B4-97': 'Poissonnier',
    'B4-98': 'Primeur / maraîcher',
    'B4-99': 'Vente en ligne',
    'P1-57': 'Personnels MLC',
    'P1-58': 'Particuliers web',
    'P1-59': 'Personnels clients',
    'P1-60': 'Brigadiers',
    'P1-61': 'Particuliers',
  },
  'activation': {
    'aucun_email': 'Sans email',
    'aucun_email_color': 'red.fail',
    'connecte': 'Connectés',
    'connecte_color': 'green.success',
    'non_connecte': 'Non connectés',
    'non_connecte_color': 'red.fail',
    'aucune_commande': 'N\'ont pas commandé',
    'aucune_commande_color': 'orange.warning',
    'ont_commande': 'Ont commandé',
    'ont_commande_color': 'green.success',
  },
  'motif_de_blocage': {
    '01': '01 - Fermeture établissement',
    '02': '02 - Non paiement client',
    '03': '03 - Règlement impayé',
    '04': '04 - Client attribué à un autre adhérent',
    '05': '05 - Changement de centrale',
    '06': '06 - Client perdu',
    '07': '07 - Redressement judiciaire',
    '08': '08 - Changement de propriétaire',
    '09': '09 - Client centrale (non facturable)',
    '10': '10 - Autres',
    '11': '11 - Regroupement de comptes',
    '12': '12 - En cours de duplication',
    '13': '13 - Huissier',
    '14': '14 - Sans CA depuis 6 mois',
    '15': '15 - Opposition sur vente',
    '16': '16 - Coface',
    '17': '17 - Liquidation judiciaire',
    '88': '88 - Dépassement encours',
    '89': '89 - Dépassement échéance',
  },
  'jours': {
    'dimanche': 'dimanche',
    'lundi': 'lundi',
    'mardi': 'mardi',
    'mercredi': 'mercredi',
    'jeudi': 'jeudi',
    'vendredi': 'vendredi',
    'samedi': 'samedi',
  },
  'mes_informations': {
    'modification_alerte': 'Vous souhaitez faire une modification ?',
    'contacter_commercial': 'Contacter votre commercial',
    'votre_commercial': 'Votre commercial',
    'mes_adresses': 'Mes adresses',
    'adresses_de_facturation': 'Adresses de facturation',
    'adresses_de_livraison': 'Adresses de livraison',
    'adresse_de_retrait': 'Adresse de retrait',
    'mon_identite': 'Mon identité',
    'mon_entreprise': 'Mon entreprise',
    'mes_coordonnees': 'Mes coordonnées',
    'numero_de_compte': 'Numéro de compte : ',
    'siret': 'SIRET : ',
    'tva': 'TVA : ',
    'par_mail': 'Par mail',
    'adresses_enlevement': 'Adresses d’enlèvement',
    'date_de_livraison': 'Date de livraison : ',
    'cut_off_de_preparation': 'Cut off de préparation : ',
    'les_tournees': 'Les tournées',
    'tournee_enlevement': "Tournée d'enlèvement n°{{numero}}",
    'tournee_livrante': 'Tournée livrante n°{{numero}}'
  },
  'contact': {
    'societe_commerciale': 'Société commerciale',
    'televente': 'Télévente',
    'commercial': 'Commercial',
    'copier_email': "Copier l'email",
    'non_renseigne': 'Non renseigné'
  },
  'commande': {
    'nombre_commandes': '{{count}} COMMANDE',
    'nombre_commandes_one': '{{count}} COMMANDE',
    'nombre_commandes_other': '{{count}} COMMANDES',
    'nombre_commandes_many': '{{count}} COMMANDES',
    'nombre_commandes_plural': '{{count}} COMMANDES',
    'commande': 'COMMANDE',
    'commande_one': 'COMMANDE',
    'commande_other': 'COMMANDES',
    'commande_plural': 'COMMANDES',
    '2_derniers_mois': 'Les 2 derniers mois',
    '3_6_mois': 'De 3 à 6 mois',
    'en_cours': 'En cours',
    'livrees': 'Livrées',
    'livree': 'Livrée',
    'annulees': 'Annulées',
    'en_cours_de_traitement': 'En cours de traitement',
    'voir_le_detail': 'Voir le détail',
    'non_definie': 'Non définie',
    'saisie': 'Saisie',
    'annulee': 'Annulée',
    'ferme': 'Fermée',
    'mise_en_prepa': 'Mise en préparation',
    'prepa_en_cours': 'Préparation en cours',
    'prepa_terminee': 'Préparation terminée',
    'facturee': 'Facturée',
    'total_ttc': 'Total TTC',
    'total_ht': 'Total HT',
    'total_tva': 'Total TVA',
    'livraison_du': 'Livraison du',
    'commande_du': 'Commande du',
    'commande_marketplace_du': 'Commande {{marketplace}} du',
    'date_de_commande': 'Date de commande',
    'passee_le': 'Commande passée le',
    'adresse_facturation': 'Adresse de facturation',
    'adresse_livraison': 'Adresse de livraison',
    'reference_de_commande': 'Référence de commande',
    'ajouter_produit': 'Pour ajouter un produit',
    'supprimer_produit_changer_quantite': 'Pour supprimer un produit, changer des quantités',
    'passer_nouvelle_commande': 'Passer une nouvelle commande',
    'contacter_conseiller': 'Contacter mon conseiller',
    'vous_etes_trompe': 'Vous vous êtes trompé ?',
    'on_vous_accompagne': 'On vous accompagne.',
    'bon_de_commande': 'Bon de commande',
    'details_de_ma_commande': 'Détails de ma commande',
    'frais_de_livraison': 'Frais de livraison',
    'n°': 'N°',
    'documents_non_disponibles': 'Documents non disponibles',
    'modale_changer_adresse_header': 'Selectionnez votre service',
    'digital': 'France Frais Connect',
    'ancien_web': 'Ancien Web',
    'televente': 'Télévente',
    'commercial': 'Commercial',
    'ffcommerce': 'Commercial (FFC)',
    'article': '{{count}} article',
    'article_one': '{{count}} article',
    'article_other': '{{count}} articles',
    'article_many': '{{count}} articles',
    'article_plural': '{{count}} articles',
    'remplacer_article': 'Remplacer <strong>{{nom}}</strong>',
    'chercher_tout_catalogue': 'Rechercher dans tout le catalogue',
    'voir_produits_ub': 'Tous les produits de l’UB : {{nom}}',
    'chercher_dans_ub': 'Rechercher dans l’UB',
    'aucun_produit_ub': 'Aucun produit ne correspond à votre recherche',
    'remplacement_aucun_article': 'Désolé, aucun article de remplacement n’a été trouvé',
    'remplacement_aucun_produit_marche':
      'Aucun produit marché trouvé. Décochez le filtre « Produits marché » pour voir d’autres articles.',
    'remplacement_aucun_filtre':
      'Aucun article ne correspond aux filtres ou à la recherche.',
    'par_multiple': 'par {{quantite}} {{unite}}',
    'par_colis': 'par colis de {{quantite}} {{unite}}',
    'de_multiple_facturation': 'de {{multiple_facturation}} {{unite_facturation}}',
    'ajouter_cette_commande_panier': 'Commander à nouveau',
    'ajouter_cette_commande_panier_tooltip': 'En cliquant, tous les articles seront ajoutés dans un nouveau panier à la date de livraison actuellement selectionnée.',
    'vous_souhaitez_renouveler_commande': 'Vous souhaitez renouveler cette commande ?',
    'gagner_temps': 'Ajoutez en un clic tous les produits de cette commande avec leurs quantités !',
    'a_payer': 'À payer',
    'payee': 'Payée',
    'aucune_commande': "Vous n'avez aucune commande sur cette période",
    'tooltip_tva': 'Montant de la TVA',
    'produits': 'Produits',
    'statut': 'Statut',
    'statut_tooltip': 'Statut de la commande',
    'actions': 'Actions',
    'deja_commande': 'Déjà commandé :',
    'pour_livraison_du': 'Pour votre livraison du {{date}}.',
    'deja_commande_tooltip_ligne1': 'Vous avez déjà commandé',
    'deja_commande_tooltip_ligne2': '<bold>{{quantite}} {{unite}}</bold> pour le <bold>{{date}}</bold>',
    'type': 'Type de commande',
    'articles_ajouter_au_panier': 'Les produits ont été ajoutés au panier avec les mêmes quantités.',
    'je_souhaite': 'Je souhaite',
    'ajouter_un_produit': 'Ajouter un produit',
    'je_passe_une_nouvelle_commande': 'Je passe une nouvelle commande',
    'supprimer_produit_changer_quantites': 'Supprimer un produit, changer des quantités',
    'je_contact_mon_conseiller': 'Je contact mon conseiller',
    'renouveler_cette_commande': 'Renouveler cette commande',
    'j_ajoute_tous_ces_produits': 'J\'ajoute tous ces produits à mon panier',
    'AF': 'AVOIR',
    'AV': 'AVOIR',
    'CA': 'COMMANDE',
    'CO': 'COMMANDE',
    'FC': 'COMMANDE',
    'FF': 'REGUL',
    'FQ': 'REGUL',
    'MD': 'MULTI DESTINATAIRE',
    'PD': 'COMMANDE',
    'PH': 'PREVISIONNELLE HISTORIQUE',
    'PR': 'PREVISONNELLE'
  },
  'factures_avoirs': {
    'facture': 'Facture',
    'avoir': 'Avoir',
    'factures_et_avoirs': '{{count}} FACTURE ET AVOIR',
    'factures_et_avoirs_one': '{{count}} FACTURE ET AVOIR',
    'factures_et_avoirs_other': '{{count}} FACTURES ET AVOIRS',
    'factures_et_avoirs_many': '{{count}} FACTURES ET AVOIRS',
    'factures_et_avoirs_plural': '{{count}} FACTURES ET AVOIRS',
    'facture_n°': 'Facture n°',
    'date_emission': 'Date d’émission',
    'echeance': 'Échéance',
    'total_ttc': 'Total TTC',
    'total_ht': 'Total HT',
    'statut': 'Statut',
    'action': 'Action',
    'telecharger': 'Télécharger',
    'telecharger_tout': 'Télécharger tout',
    'n°': 'n°',
    'numero_de_facture': 'Numéro de facture',
    'factures': 'Factures',
    'avoirs': 'Avoirs',
    'alerte': "Attention ! Le statut de la facture n'est mis à jour qu'une fois par jour.",
    'aucune_facture_ou_avoir': 'Aucune facture ou avoir disponible pour cette période.',
    '2_derniers_mois': 'Les 2 derniers mois',
    '6_derniers_mois': 'Les 6 derniers mois',
    '12_derniers_mois': 'Les 12 derniers mois'
  },
  'recherche': {
    'resultat_pour_mobile': 'Les résultats pour',
    'resultat_pour_desktop': 'Les résultats de recherche pour',
    'recherche_produits': 'Chercher un produit',
    'chargement_catalogue': 'Nous chargeons votre catalogue ...',
    'voir_tous_les_produits': 'Voir tous les produits',
    'produits': 'Produits',
  },
  'fiche_produit': {
    'description': 'Description',
    'caracteristiques': 'Caractéristiques',
    'dimensions_mm': 'Dimensions (mm)',
    'poids_net': 'Poids net',
    'poids_net_kg': '{{value}} kg',
    'table': {
      'ingredient_nutrition': 'Ingrédients et nutrition',
      'informations_nutritionelles': 'Informations nutritionnelles',
      'pour100gml': 'Pour 100 g/ml',
      'ajr': 'Apports journaliers recommandés (%)',
      'ajr_short': 'AJR (%)',
      'ingredients_manquants': 'La liste des ingrédients n’a pas encore été communiquée.',
      'allergenes': 'Allergènes :'
    },
    'fiche_produit_pdf': {
      'telecharger_fiche_produit': 'Télécharger la fiche technique',
      'fiche_produit_non_disponible': 'Fiche technique non disponible',
      'fiche_produit': 'Fiche produit',
      'fiche_technique_pdf': 'Fiche technique.pdf'
    },
    'apercu_produit': 'Aperçu produit',
    'voir_detail_produit': 'Voir le détail produit'
  },
  'select_client': {
    'greeting': 'Content de vous revoir !',
    'selectionnez_compte':'Sélectionnez un compte client pour continuer',
    'client_de': 'Client de {{nom_societe}}',
    'mon_catalogue_france_frais': 'Mon catalogue France Frais',
  },
  'menu_catalogue': {
    'suggestion_produit': 'En ce moment',
    'catalogues_partenaires': 'Les produits catalogues partenaires',
    'catalogue_MATFER01': 'Catalogue Matfer',
  },
  'catalogue': {
    'aucun_produit': 'Aucun produit dans ce rayon !',
    'les_promotions': 'Les Promotions',
    'les_indispensables': 'Les Indispensables',
    'indispensables': 'Indispensables',
    'promotions': 'Promotions',
    'promotion_du_moment': 'Les promotions du moment',
    'voir_tout_promotion': 'Voir toutes les promotions',
    'voir_tout': 'Voir tout',
    'plus_de_produit': 'Plus de produits',
    'commander_maintenant': 'Commander maintenant',
    'commander_maintenant_pour': 'Commander maintenant pour',
    'produits_marque_proprietaire': 'Les indispensables',
    'fin_liste': 'Fin de votre catalogue',
    'filtre': {
      'promotions': 'Promotions',
      'produit_marche': 'Produits marché',
      'promo': 'Promo',
      'labels': 'Labels',
      'no_labels': 'Pas de labels',
      'origine': 'Origine',
      'a-z': 'A - Z',
      'pertinence': 'Pertinence',
      'tri': 'Tri : ',
      'filtrer': 'Filtrer',
      'trier': 'Trier',
      'trier_par': 'Trier par',
      'afficher': 'Afficher',
      'tout_effacer': 'Tout effacer',
      'non_surgele_surgele': 'Non surgelé/Surgelé',
      'non_surgele': 'Non surgelé',
      'surgele': 'Surgelé',
      'effacer': 'Effacer tous les filtres',
      'sourcing': 'Sourcing',
      'afficher_marketplace': 'Catalogues partenaires',
      'fromage': 'Caractéristiques fromage',
      'famille_fromage': 'Type de fromage',
      'type_de_lait': 'Type de lait',
      'traitement_thermique_du_lait': 'Traitement du lait',
    }
  },
  'fromage': {
    'famille': {
      'CH': 'Chèvre',
      'FF': 'Fromage fondu',
      'PF': 'Pâte fraîche',
      'PMCF': 'Pâte molle croûte fleurie',
      'PMCL': 'Pâte molle croûte lavée',
      'PP': 'Pâte persillée',
      'PPC': 'Pâte pressée cuite',
      'PPNC': 'Pâte pressée non cuite',
    },
    'lait': {
      'BR': 'Brebis',
      'BU': 'Bufflonne',
      'CH': 'Chèvre',
      'CB': 'Chèvre-Brebis',
      'VA': 'Vache',
      'VB': 'Vache-Brebis',
      'VC': 'Vache-Chèvre',
      'VCB': 'Vache-Chèvre-Brebis',
    },
    'traitement': {
      'LMF': 'Lait micro-filtré',
      'LC': 'Lait cru',
      'LP': 'Lait pasteurisé',
      'LS': 'Lait stérilisé',
      'LT': 'Lait thermisé',
      'LCLT': 'Lait thermisé et lait cru',
    },
  },
  'accueil': {
    'bonjour': 'Bonjour {{nom}} !',
    'salutation': {
      'bonjour': 'Bonjour {{prenom}},',
      'bonjour_sans_prenom': 'Bonjour,',
      'pret_a_commander_chez': 'prêt à commander chez {{societe}} ?',
      'pret_a_commander': 'prêt à commander ?',
    },
    'mes_dernieres_commandes': 'Mes dernières commandes',
    'cartes': {
      'cadencier': {
        'sous_titre': 'Vos produits récurrents',
      },
      'listes': {
        'sous_titre': 'Vos produits favoris',
      },
      'saison': {
        'sous_titre': "Vos produits commandés l'année dernière à la même période",
      },
    },
    'pastille_client': {
      'aria_label': 'Point de livraison : {{raison_sociale}}, {{ville}}',
      'aria_label_sans_ville': 'Point de livraison : {{raison_sociale}}',
    },
    'image_ambiance': {
      'alt': "Photo d'ambiance de votre métier",
    },
    'chargement_catalogue': 'Nous chargeons votre catalogue. Lors de votre première connexion, cela peut prendre 2 minutes, merci pour votre patience.',
    'chargement_tournees': 'Chargement de vos tournées de livraison',
    'compte_bloque': "Votre compte n'est pas configuré pour prendre des commandes, veuillez contacter votre représentant.",
    'mes_paniers_en_cours': 'Mes paniers en cours ({{nombre_paniers}})',
    'paniers_en_cours': 'Paniers en cours ({{nombre_paniers}})',
    'afficher_paniers': 'Afficher tous mes paniers',
    'voir_paniers': 'Voir',
    'pour_livraison': 'Pour livraison du ',
    'operation_commerciale': {
      'titre': 'En ce moment',
      'voir_tout': 'Voir tout'
    },
    'devis_personnalises': {
      'titre': 'Ma proposition commerciale',
      'prepare_par_label': 'Préparé par',
      'prepare_par_commercial': 'Préparé par {{prenom}} {{nom}} — mis à jour le {{date}}',
      'voir_le_devis': 'Voir le devis',
      'votre_commercial': 'Votre commercial ',
      'mise_a_jour': 'Mise à jour le {{date}}',
      'nouveau_message': '{{count}} nouveau message',
      'nouveau_message_one': '{{count}} nouveau message',
      'nouveau_message_other': '{{count}} nouveaux messages',
      'messages': '{{count}} message',
      'messages_one': '{{count}} message',
      'messages_other': '{{count}} messages',
      'messages_singulier': '{{count}} message',
      'messages_pluriel': '{{count}} messages',
      'nouveau_message_singulier': '{{count}} nouveau message',
      'nouveau_message_pluriel': '{{count}} nouveaux messages',
    },
  },
  'footer': {
    'conseiller_ecoute': 'À votre écoute',
    'conseiller_ecoute_grand_compte': 'Contacter votre commercial',
    'mail': 'Par mail',
    'telephone': 'Par téléphone',
    'consulter_rayons': 'Consultez nos rayons',
    'nos_rayons': 'Nos rayons',
    'a_propos': 'A propos',
    'contactez_nous': 'Contactez-nous',
    'tel': 'Tel.',
    'e_mail': 'E-mail.',
    'votre_conseiller': 'Votre conseiller :',
    'mentions_legales': 'Mentions légales',
    'engagements': 'Nos engagements',
    'politique_confidentialite': 'Politique de confidentialité',
    'gestion_cookies': 'Gestion des cookies',
    'cgv': 'CGV',
    'cgu': 'CGU'
  },
  'informations_legales': {
    'titre': 'Informations légales',
    'consulter': 'Consulter',
    'lien_externe': 'Lien externe',
    'document_pdf': 'Document PDF',
    'cgv': 'Conditions Générales de vente',
    'cgu': 'Conditions Générales d’utilisation'
  },
  'modale_nomenclature': {
    'chargement': 'Chargement de votre menu'
  },
  'modale_enlevement': {
    'contacter_representant': "Afin d'organiser le retrait de vos marchandises, n'oubliez pas de contacter votre représentant"
  },
  'modale_differer': {
    'deplacement': 'Votre produit va être <strong>déplacé au panier du {{date_de_livraison}}</strong>',
    'aucune_livraison_possible': 'Aucune livraison possible pour le moment après cette date.'
  },
  'preferences': {
    'alertes': 'Mes alertes commandes',
    'activer': 'Tout activer',
    'email': 'Email',
    'mobile': 'App mobile',
    'livraison': 'Rappel de prochaine livraison (la veille)',
    'livraison_mobile': 'Rappel de prochaine livraison<br />(la veille)',
    'paniers': 'Rappel de paniers à valider',
    'mode_assistance_01': 'Les préférences dans le compte client sont propres à chaque contact et ne sont pas globales au client. <strong>Il n’est donc pas possible de modifier ces préférences depuis le mode assistance.</strong>',
    'mode_assistance_02': 'Si un contact souhaite modifier ses préférences, il doit se connecter lui-même à France Frais connect et les gérer dans la rubrique « Mes préférences ».'
  },
  'session': {
    'session_bientot_expiree': 'Session bientôt expirée',
    'prolonger_session': 'Prolonger la session',
    'prolongation': 'Prolongation ...',
    'delai_expiration': 'Votre session expirera dans {{minutes}} minutes.'
  },
  'form': {
    'file_drop_zone': {
      'erreur_taille_fichier': 'Le fichier dépasse la taille maximale autorisée (5 Mo)',
      'erreur_envoi_fichier': 'L\'envoi du fichier a échoué, réessayez.'
    },
    'societe_commerciale': {
      'titleAjouter': 'Ajouter une société commerciale',
      'titleModifier': 'Modifier une société commerciale',
      'dropzone': 'Déposez votre fichier ou cliquez sur la zone',
      'ajouter': 'Ajouter',
      'modifier': 'Modifier',
      'ajoutee': 'La société commerciale a été enregistrée.',
      'modifiee': 'La société commerciale a été modifiée.',
      'supprimer': 'Supprimer',
      'ajouter_lien': 'Ajouter un lien',
      'annuler': 'Annuler',
      'valider': 'Valider',
      'general': 'Informations générales',
      'id_base_label': 'ID Base',
      'id_base_placeholder': "Sélectionnez l'ID base",
      'code_societe_commerciale_label': 'Code société commerciale',
      'code_societe_commerciale_placeholder': 'Sélectionnez le code de la société',
      'nom_commercial_label': 'Nom commercial',
      'nom_commercial_placeholder': 'Nom commercial de la société',
      'ffconnect': 'Informations FFConnect',
      'permettre_commande_retrait_label': 'Permettre le retrait de commande',
      'permettre_commentaire_commande_label': 'Autoriser un commentaire à la commande',
      'permettre_traduction_allemande_label': 'Autoriser la traduction allemande pour les opérations commerciales',
      'message_validation_livraison_label': 'Message validation livraison',
      'message_validation_livraison_placeholder': "Message à la validation d'une livraison",
      'message_validation_enlevement_label': 'Message validation enlèvement',
      'message_validation_enlevement_placeholder': "Message à la validation d'un retrait au dépôt",
      'contact': 'Informations contact',
      'adresse_label': 'Adresse',
      'adresse_placeholder': 'Adresse de la société',
      'telephone_label': 'Téléphone',
      'telephone_placeholder': 'Téléphone de la société',
      'email_label': 'Email',
      'email_placeholder': 'Email de la société',
      'visuel': 'Informations visuelles',
      'couleur_label': 'Couleur principale de la société',
      'logo_label': 'Logo de la société (jpg ou png)',
      'cgv_label': 'CGV de la société (pdf)',
      'reinitialiser_cgv': 'Réinitialiser les acceptations de CGV',
      'reinitialiser_cgv_tooltip': 'Réinitialise les acceptations de CGV de tous les clients de la société. Ils devront accepter à nouveau les CGV.',
      'reinitialiser_cgv_modal': {
        'titre': 'Réinitialiser les acceptations de CGV',
        'message': 'Êtes-vous sûr de vouloir réinitialiser les acceptations de CGV pour tous les clients de cette société ? Ils devront accepter à nouveau les CGV lors de leur prochaine commande.',
        'confirmer': 'Réinitialiser',
        'annuler': 'Annuler'
      },
      'cgu_label': 'CGU de la société (pdf)',
      'footer': 'Informations footer',
      'url_lien': 'URL pour le lien',
      'label_lien': 'Libellé du lien'
    }
  },
  'commercial': {
    'retour_fiche_client': 'Retour à la fiche client',
    'commandes_pdf': 'Commandes PDF',
    'mode_commercial': 'Vue Commerce',
    'mode_client': 'Vue Client',
  },
  'kpis': {
    'erreur': 'Erreur lors du chargement des KPIs',
    'total_clients': 'Total clients',
    'nb_connectes': 'Clients connectés',
    'nb_connectes_tooltip': '• {{nb_connectes}} clients se sont connectés à FFConnect au cours des 30 derniers jours.<br />• {{nb_connectes_total}} clients se sont connectés à FFConnect depuis le début.',
    'non_connecte': 'pas connectés',
    'non_connecte_tooltip': 'Clients qui ne se sont pas connectés sur FFConnect au cours des 30 derniers jours.',
    'panier_valide': 'Clients qui ont commandé',
    'panier_valide_tooltip': '• {{periode_en_cours}} clients ont commandé sur FFConnect au cours des 30 derniers jours.<br />• {{nb_panier_valide_total}} clients ont commandé sur FFConnect depuis le début.',
    'clients_pas_connectes': 'Clients pas connectés',
    'clients_pas_commande': "Clients qui n'ont pas commandé",
    'clients_pas_connectes_tooltip': '• {{x30}} clients qui ne se sont pas connectés sur FFConnect au cours des 30 derniers jours<br />• {{xEver}} clients qui ne se sont pas connectés sur FFConnect depuis le début',
    'clients_pas_commande_tooltip': "• {{x30}} clients qui n'ont pas commandé sur FFConnect au cours des 30 derniers jours parmi les clients connectés<br />• {{xEver}} clients qui n'ont pas commandé sur FFConnect depuis le début parmi les clients connectés"
  },
  'analytics': {
    'modale_consentement_titre': 'Souhaitez-vous contribuer à l’amélioration de France Frais Connect en partageant des statistiques d’utilisation ?',
    'amelioration_france_frais_connect': 'Amélioration France Frais Connect',
    'j_accepte_le_partage': 'J\'accepte le partage'
  },
  'maintenance': {
    'title': 'Maintenance en cours',
    'contact_support': 'Pour toute question, contactez le support technique.'
  },
  'historique_livraison': {
    'title': 'Historique',
    'aucun_historique': 'Aucun historique disponible.',
    'historique_achat': 'Historique d’achat',
    'historique_achat_tooltip': 'Historique des achats du produit sur les 90 derniers jours.',
    'pas_historique_achat_recent': 'Aucun historique récent',
    'derniers_achats': '5 derniers achats',
    'voir_plus': 'Voir plus',
    'prix': 'Prix',
    'categorie': 'Catégorie',
    'prix_unitaire': '{{prix}} € HT/{{unite}}',
    'prix_unitaire_avec_quantite': '{{quantite}} {{uniteQuantite}} à {{prix}} € HT/{{unite}}',
    'evolution': {
      'en-hausse': {
        'titre': 'Ligne en hausse',
        'description': 'Hausse d’au moins 30 % du poids commandé au cours des 30 derniers jours ({{p1}}) par rapport aux 30 jours d’avant ({{p2}}).',
      },
      'gagne': {
        'titre': 'Ligne gagnée',
        'description': 'Commandée au cours des 30 derniers jours ({{p1}}) alors qu’elle n’était pas commandée les 30 jours d’avant ({{p2}}).',
      },
      'stable': {
        'titre': 'Ligne stable',
        'description': 'Quantité commandée au cours des 30 derniers jours ({{p1}}) équivalente aux 30 jours d’avant ({{p2}}) (variation inférieure à 30 %).',
      },
      'en-baisse': {
        'titre': 'Ligne en baisse',
        'description': 'Baisse d’au moins 30 % du poids commandé au cours des 30 derniers jours ({{p1}}) par rapport aux 30 jours d’avant ({{p2}}).',
      },
      'perdu': {
        'titre': 'Ligne perdue',
        'description': 'Pas commandée au cours des 30 derniers jours ({{p1}}) alors qu’elle était commandée les 30 jours d’avant ({{p2}}).',
      },
      'a-gagner': {
        'titre': 'Ligne pas commandée',
        'description': 'Pas commandée au cours des 60 derniers jours ({{p3}}).',
      },
    },
  },
  'grand_compte': {
    'chercher_un_produit': 'Chercher un produit',
    'decouvrez_nos_gammes': 'Découvrez nos gammes de produits',
    'categories': 'Tous les rayons',
    'sav_question': 'Vous avez une question ?',
    'erreur_categories': 'Erreur lors du chargement des catégories',
    'conditionnement': 'Conditionnement',
    'voir_details': 'Voir détails',
    'rechercher_placeholder': 'Rechercher un produit',
    'affiner_par_rayons': 'Affiner par rayon :',
    'resultats': 'Résultats :',
    'reference': 'Référencé',
    'detention': 'Détention',
    'nombre_societes_one': '{{count}} société',
    'nombre_societes_other': '{{count}} sociétés',
    'reference_par': {
      'groupe': 'National',
      'filiale': 'Filiale'
    },
    'detention_section': {
      'title_one': 'Détention - commercialisé dans {{count}} société',
      'title_other': 'Détention - commercialisé dans {{count}} sociétés',
      'title_many': 'Détention - commercialisé dans {{count}} sociétés',
      'title_plural': 'Détention - commercialisé dans {{count}} sociétés',
      'societe_commerciale': 'Société commerciale',
      'vendu_3_derniers_mois': 'Quantités vendues',
      'vendu_3_derniers_mois_tooltip': 'Quantités vendues au cours des 3 derniers mois',
      'aucune_societe_vendu': 'Aucune société n\'a vendu ce produit au cours des 3 derniers mois'
    },
  },
  'calendar': {
    'weekdays': {
      'short': ['D', 'L', 'M', 'M', 'J', 'V', 'S']
    }
  },
  'codes': {
    'code_client': 'Code article client :',
    'code_generique': 'Code générique :'
  },
  'debug': {
    'produit_marche': {
      'titre': 'Debug Produit Marché',
      'client_id': 'ID Client:',
      'charger_infos': 'Charger les infos générales',
      'statut_affichage_produit_marche_bo': 'Affichage du produit marché dans le BO',
      'affichage_produit_marche': 'Affichage produit marché:',
      'tester_un_article': 'Tester un article',
      'tester_article': 'Tester l’article',
      'test_article': 'Test de l’article:',
      'statistiques_catalogue': 'Statistiques du catalogue',
      'total_articles_catalogue': 'Total d’articles dans le catalogue',
      'articles_produit_marche': 'Articles Produit Marché',
      'pourcentage_produit_marche': 'Pourcentage d’articles Produit Marché',
      'metriques': 'Métriques',
      'valeur': 'Valeur',
      'existe_catalogue': 'Existe dans le catalogue',
      'produit_marche_selon_tolede': 'Produit marché selon Tolede',
      'sera_affiche_produit_marche': 'Sera affiché comme produit marché',
    }
  },
  'mes_droits': {
    'title': 'Mes droits',
    'error_loading': 'Erreur lors du chargement des droits',
    'no_data': 'Aucune donnée disponible',
    'synako_user_info': 'Vous consultez les droits du commercial actuellement sélectionné',
    'user_info': 'Informations utilisateur',
    'code_utilisateur': 'Code utilisateur',
    'nom_prenom': 'Nom et prénom',
    'email': 'Email',
    'not_specified': 'Non renseigné',
    'permissions': 'Permissions',
    'dero_autorisee': 'Injection dérogation ligne à ligne (commande)',
    'devis_en_tarif_autorise': 'Validation des dérogations (devis)',
    'prix_plancher_autorise': 'Prix sous le plancher',
    'access_scope': 'Périmètre d\'accès',
    'societes_autorisees': 'Sociétés commerciales autorisées',
    'all_societies': 'Toutes les sociétés',
    'client_autorises': 'Clients autorisés',
    'all_clients': 'Tous les clients',
    'refresh_button': 'Rafraîchir mes droits',
    'refresh_success': 'Droits rafraîchis avec succès',
    'refresh_error': 'Erreur lors du rafraîchissement des droits',
  },
  'mes_droits_synako': {
    'title': 'Sélection du commercial',
    'error_loading': 'Erreur lors du chargement de la liste des commerciaux',
    'info_message': 'Sélectionnez le commercial France Frais que vous souhaitez impersonner',
    'change_success': 'Commercial sélectionné avec succès',
    'filters': 'Filtres',
    'search': 'Recherche',
    'search_placeholder': 'Rechercher par nom, prénom, email ou code...',
    'filter_societe': 'Société commerciale',
    'all_societies': 'Toutes les sociétés',
    'filter_dero': 'Injection dérogation ligne à ligne (commande)',
    'filter_devis_tarif': 'Validation des dérogations (devis)',
    'filter_prix_plancher': 'Prix plancher',
    'list_title': 'Commerciaux disponibles',
    'no_results': 'Aucun commercial trouvé avec ces critères',
    'table': {
      'code': 'Code',
      'nom': 'Nom',
      'email': 'Email',
      'societes': 'Sociétés',
      'clients': 'Clients',
      'dero': 'Déro.',
      'devis_tarif': 'Devis/Tarif',
      'prix_plancher': 'Prix plancher',
      'action': 'Action',
    },
    'all': 'Tous',
    'select': 'Sélectionner',
  },
  'branding': {
    'annonce_nouvelle_identite': {
      'titre': 'France Frais change de tête !',
      'texte': 'Nous faisons peau neuve avec une nouvelle identité.',
    },
    'slogan': 'Une fédération de distributeurs <br />qui appartient à des agriculteurs.',
  },
  'file_size': {
    'zero_bytes': '0 Bytes',
    'bytes': 'Bytes',
    'kb': 'KB',
    'mb': 'MB',
    'gb': 'GB',
  },
  'client': {
    'conversations': {
      'titre': 'Conversations',
      'sous_titre': 'La télévente et votre commercial sont à votre écoute',
      'sous_titre_commercial': 'avec {{raison_sociale}}',
      'equipe_aide': 'Notre équipe est là pour vous aider',
      'commencer_conversation': 'Commencer une conversation',
      'appeler': 'Appeler {{nom}}',
      'bouton_appeler': 'Appeler',
      'reduire_chatbox': 'Réduire cette chatbox',
      'onglet_en_cours': 'Mes conversations',
      'onglet_toutes': 'Toutes les conversations',
      'onglet_terminees': 'Conversations terminées',
      'aucune_conversation': 'Aucune conversation',
      'aucune_discussion_cloturee': 'Aucune conversation clôturée',
      'titre_defaut': 'Conversation',
      'modifier_titre': 'Modifier le titre',
      'hier': 'Hier',
      'aucun_message': 'Aucun message dans cette conversation.',
      'conversation_terminee': 'Cette conversation a été clôturée. Vous pouvez l\'ouvrir de nouveau en envoyant un message.',
      'conversation_cloturee_info': 'Cette conversation est clôturée, vous la trouverez dans vos discussions clôturées. Vous pouvez l\'ouvrir de nouveau en envoyant un message.',
      'terminer_conversation': 'La réponse me convient, terminer la conversation.',
      'placeholder_message': 'Tapez votre message',
      'envoyer': 'Envoyer',
      'ajouter_piece_jointe': 'Ajouter un document',
      'ajouter_image': 'Ajouter une image',
      'taille_fichier_ko': '{{taille}} Ko',
      'format_non_supporte': 'Le format du fichier "{{nom}}" n\'est pas supporté (formats acceptés : JPEG, PNG, GIF, WebP, PDF, Word, Excel)',
      'enregistrer_image': 'Enregistrer',
      'enregistrement_en_cours': 'Enregistrement...',
      'image_enregistree': 'Image enregistrée dans la galerie',
      'image_enregistree_court': 'Enregistré !',
      'erreur_enregistrement_image': 'Erreur lors de l\'enregistrement de l\'image',
      'erreur_enregistrement_court': 'Erreur',
      'permission_galerie_refusee': 'Permission d\'accès à la galerie refusée',
      'taille_inconnue': 'Impossible de vérifier la taille du fichier "{{nom}}"',
      'nouvelle': {
        'titre': 'Nouvelle conversation',
        'retour': 'Retour',
        'message_accueil': 'Bonjour,\nAfin de pouvoir répondre au mieux à votre demande, veuillez indiquer la raison de votre message.',
        'france_frais_connect': 'France Frais Connect',
        'raison_commande': 'Commande',
        'raison_compte_client': 'Compte client',
        'raison_livraison': 'Livraison',
        'raison_autres': 'Autres',
        'placeholder_message': 'Tapez votre message',
        'envoyer': 'Envoyer',
        'titre_conversation_date': 'Conversation du {{date}}',
      },
    },
    'mes_produits': {
      'ub_essentielles': {
        'titre': 'UB essentielles',
        'aucun_profil': 'Aucune UB essentielle pour ce client.',
        'aucun_item_filtre': 'Aucune UB ne correspond à ce filtre.',
        'voir_tous_les_produits': 'Voir tous les produits de l\'UB',
        'filtres': {
          'tout': 'Tout',
          'actives': 'Actives',
          'actives_one': 'Active',
          'actives_other': 'Actives',
          'actives_many': 'Actives',
          'actives_plural': 'Actives',
          'perdu': 'Perdu',
          'perdu_one': 'Perdue',
          'perdu_other': 'Perdues',
          'perdu_many': 'Perdues',
          'perdu_plural': 'Perdues',
          'en_baisse': 'En baisse',
          'a_gagner': 'À gagner',
        },
        'section_statut': {
          'gagne': 'UB active',
          'ras': 'UB active',
          'perdu': 'UB perdue',
          'en-baisse': 'UB en baisse',
          'a-gagner': 'UB à gagner',
        },
        'section_regle': {
          'gagne': '<strong>UB active</strong> : l\'UB est active si au moins un article de l\'UB a été commandé au cours des 30 derniers jours.',
          'ras': '<strong>UB active</strong> : l\'UB est active si au moins un article de l\'UB a été commandé au cours des 30 derniers jours.',
          'perdu': '<strong>UB perdue</strong> : l\'UB est perdue si aucun article n\'a été commandé dans l\'UB au cours des 30 derniers jours par rapport aux 30 jours d\'avant.',
          'en-baisse': '<strong>UB en baisse</strong> : l\'UB est en baisse si le poids des articles commandés a baissé de 30% au cours des 30 derniers jours par rapport aux 30 jours d\'avant.',
          'a-gagner': '<strong>UB à gagner</strong> : l\'UB est à gagner si aucun article de l\'UB n\'a été commandé au cours des 60 derniers jours.',
        },
      },
    },
  },
  'marketplace': {
    'FF': 'Notre catalogue',
    'MATFER01': 'Matfer',
    'catalogue_MATFER01': 'Catalogue Matfer',
    'titre_catalogue': 'Catalogue {{nom}}',
    'erreur_chargement_panier': 'Erreur lors du chargement du panier',
  },
};
